import * as i0 from '@angular/core';
import { Component, Input, Injectable, EventEmitter, Inject, Output, ViewChild, Pipe, Directive, ViewEncapsulation, ChangeDetectionStrategy, ContentChildren, InjectionToken, NgModule, Optional } from '@angular/core';
import * as i1$1 from '@angular/common';
import { CommonModule } from '@angular/common';
import { Subject, merge, of, take, BehaviorSubject, combineLatest, fromEvent } from 'rxjs';
import { map, takeUntil, debounceTime, tap, take as take$1, filter, switchMap, catchError, shareReplay } from 'rxjs/operators';
import * as i1 from '@capturum/builders/core';
import { InputType, DateHelper, responseData, CapturumBuilderCoreModule } from '@capturum/builders/core';
import * as i10 from '@capturum/ui/api';
import { CapturumDialogService, FilterMatchMode, CapturumTemplateDirective, CapturumSharedModule, InterpolationPipe } from '@capturum/ui/api';
import * as i3 from '@capturum/ui/button';
import { CapturumButtonModule } from '@capturum/ui/button';
import * as i2 from '@ngx-translate/core';
import { TranslateModule } from '@ngx-translate/core';
import * as i11 from '@capturum/ui/info-table';
import { InfoTableColumnType, CapturumInfoTableComponent, CapturumInfoTableModule } from '@capturum/ui/info-table';
import * as i1$2 from '@angular/cdk/layout';
import { Breakpoints } from '@angular/cdk/layout';
import * as i4 from '@capturum/ui/dynamic-filters';
import { CapturumDynamicFiltersComponent, DynamicFilterType, DynamicFiltersUtils, DYNAMIC_FILTER_COMPONENTS, dynamicFilterComponents, CapturumDynamicFiltersModule } from '@capturum/ui/dynamic-filters';
import * as i1$3 from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import * as i3$1 from '@capturum/ui/skeleton';
import { CapturumSkeletonModule } from '@capturum/ui/skeleton';
import * as i4$1 from '@capturum/ui/dropdown';
import { CapturumDropdownModule } from '@capturum/ui/dropdown';
import * as i5 from '@capturum/ui/paginator';
import { CapturumPaginatorModule } from '@capturum/ui/paginator';
import { PaginatorModule } from 'primeng/paginator';
import { CapturumCheckboxModule } from '@capturum/ui/checkbox';
import { CapturumCalendarModule } from '@capturum/ui/calendar';
import * as i16 from '@capturum/ui/cta-button';
import { CapturumCtaButtonModule } from '@capturum/ui/cta-button';
import { CapturumMultiSelectModule } from '@capturum/ui/multi-select';
import { HttpClientModule } from '@angular/common/http';
import * as i1$4 from '@capturum/api';
import { ApiService } from '@capturum/api';
import * as i1$5 from '@ngxs/store';
import { createSelector, Action, State, NgxsModule } from '@ngxs/store';
import * as i9 from '@angular/router';
import { __decorate } from 'tslib';
import * as i17 from '@capturum/ui/sidebar';
import { CapturumSidebarModule } from '@capturum/ui/sidebar';
import * as i6 from '@angular/cdk/drag-drop';
import { moveItemInArray, DragDropModule } from '@angular/cdk/drag-drop';
import * as i5$1 from 'primeng/tabview';
import { TabViewModule } from 'primeng/tabview';
import { CapturumAutocompleteModule } from '@capturum/ui/autocomplete';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { ChipsModule } from 'primeng/chips';
function ListRendererHeaderActionsComponent_ng_container_4_li_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵelement(1, "cpb-list-renderer-header-action", 6);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const action_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵattribute("data-test", (action_r1 == null ? null : action_r1.key) || (action_r1 == null ? null : action_r1.label));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("action", action_r1);
  }
}
function ListRendererHeaderActionsComponent_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ListRendererHeaderActionsComponent_ng_container_4_li_1_Template, 2, 2, "li", 5);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵpipe(3, "observablePipe");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const action_r1 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(2, 1, i0.ɵɵpipeBind1(3, 3, action_r1 == null ? null : action_r1.hidden)) !== true);
  }
}
function ListRendererFiltersComponent_ng_container_0_h5_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "h5", 5);
    i0.ɵɵlistener("click", function ListRendererFiltersComponent_ng_container_0_h5_1_Template_h5_click_0_listener() {
      i0.ɵɵrestoreView(_r6);
      i0.ɵɵnextContext();
      const _r3 = i0.ɵɵreference(3);
      return i0.ɵɵresetView(_r3.value = !_r3.value);
    });
    i0.ɵɵelement(1, "i");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const _r3 = i0.ɵɵreference(3);
    i0.ɵɵadvance(1);
    i0.ɵɵclassMapInterpolate1("filter-toggle mr-1 fas ", (_r3 == null ? null : _r3.value) ? "fa-eye" : "fa-eye-slash", "");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 4, "builders.ui.list.filters"), " ");
  }
}
function ListRendererFiltersComponent_ng_container_0_div_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 6)(1, "cap-dynamic-filters", 7, 8);
    i0.ɵɵlistener("onResetFilters", function ListRendererFiltersComponent_ng_container_0_div_4_Template_cap_dynamic_filters_onResetFilters_1_listener() {
      i0.ɵɵrestoreView(_r9);
      const ctx_r8 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r8.resetFilters());
    })("activeFiltersChange", function ListRendererFiltersComponent_ng_container_0_div_4_Template_cap_dynamic_filters_activeFiltersChange_1_listener($event) {
      i0.ɵɵrestoreView(_r9);
      const ctx_r10 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r10.onFilterChange($event));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵclassProp("global-search-enabled", ctx_r4.config == null ? null : ctx_r4.config[ctx_r4.SEARCH_BAR] == null ? null : ctx_r4.config[ctx_r4.SEARCH_BAR].enabled);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("filterStyleClass", "")("containerStyleClass", "")("storageKey", ctx_r4.key)("routeFilters", ctx_r4.routeFilters)("showResetButton", true)("showRefreshButton", ctx_r4.dynamicFilterConfig == null ? null : ctx_r4.dynamicFilterConfig.texts == null ? null : ctx_r4.dynamicFilterConfig.texts.refresh)("maxFiltersShown", ctx_r4.sidebarFiltering ? 5 : 99)("sidebarFiltering", ctx_r4.sidebarFiltering)("filterConfig", ctx_r4.dynamicFilterConfig);
  }
}
function ListRendererFiltersComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ListRendererFiltersComponent_ng_container_0_h5_1_Template, 4, 6, "h5", 1);
    i0.ɵɵelementStart(2, "div", 2, 3);
    i0.ɵɵtemplate(4, ListRendererFiltersComponent_ng_container_0_div_4_Template, 3, 11, "div", 4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const handset_r1 = ctx.ngIf;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", handset_r1.matches && ctx_r0.stackedFilters);
    i0.ɵɵadvance(1);
    i0.ɵɵclassProp("stacked", ctx_r0.stackedFilters);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.dynamicFilterConfig);
  }
}
function ListRendererResetFilterComponent_ng_container_0_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵlistener("click", function ListRendererResetFilterComponent_ng_container_0_div_1_Template_div_click_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r3 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r3.resetFilter());
    });
    i0.ɵɵelement(1, "i");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵclassMap(ctx_r2.resetFilterIcon || "fas fa-fw fa-trash-alt");
  }
}
function ListRendererResetFilterComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ListRendererResetFilterComponent_ng_container_0_div_1_Template, 2, 2, "div", 1);
    i0.ɵɵpipe(2, "displayResetFilter");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const fieldValue_r1 = ctx.ngIf;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(2, 1, fieldValue_r1));
  }
}
const _c0 = function (a0) {
  return {
    "pagination--hidden": a0
  };
};
function ListRendererPaginatorComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 7)(1, "div")(2, "div", 2)(3, "div", 8);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 9)(7, "cap-dropdown", 10);
    i0.ɵɵlistener("change", function ListRendererPaginatorComponent_div_0_Template_cap_dropdown_change_7_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.changePerPage == null ? null : ctx_r1.changePerPage.emit($event.value));
    });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(8, "div", 11);
    i0.ɵɵtext(9);
    i0.ɵɵpipe(10, "translate");
    i0.ɵɵpipe(11, "translate");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(12, "div")(13, "cap-paginator", 12);
    i0.ɵɵlistener("changePage", function ListRendererPaginatorComponent_div_0_Template_cap_paginator_changePage_13_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.changePage.emit($event));
    });
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(16, _c0, ctx_r0.loading))("formGroup", ctx_r0.paginatorForm);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(5, 10, "table.showing"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("sortAlphabetically", false)("appendTo", "body")("options", ctx_r0.perPageOptions);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate3(" ", i0.ɵɵpipeBind1(10, 12, "table.paginator.of"), " ", ctx_r0.paginator == null ? null : ctx_r0.paginator.total, " ", i0.ɵɵpipeBind1(11, 14, "table.entries"), " ");
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("pagination", ctx_r0.paginator);
  }
}
const _c1 = function (a0) {
  return {
    "pagination--visible": a0
  };
};
function ListRendererWidgetConcatenationComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "concatenate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(2, 1, ctx_r0.item, ctx_r0.parts), " ");
  }
}
function ListRendererWidgetImageComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "img", 1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassMapInterpolate1("list-renderer-widget-image list-renderer-widget-image--", ctx_r0.shape, "");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("src", ctx_r0.item[ctx_r0.field], i0.ɵɵsanitizeUrl);
  }
}
function ListRendererWidgetLinkComponent_a_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 1);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const link_r1 = ctx.ngIf;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("target", ctx_r0.target)("href", ctx_r0.type ? ctx_r0.LinkHrefType[ctx_r0.type] + link_r1 : link_r1, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", link_r1, " ");
  }
}
function ListRendererDynamicWidgetComponent_ng_template_0_Template(rf, ctx) {}
const _c2 = function (a0) {
  return {
    items: a0
  };
};
function ListRendererBulkActionsComponent_div_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵelementContainer(1, 11);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.contentTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c2, ctx_r0.selectedItems));
  }
}
function ListRendererBulkActionsComponent_cap_button_8_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "cap-button", 12);
    i0.ɵɵlistener("click", function ListRendererBulkActionsComponent_cap_button_8_Template_cap_button_click_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r4 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r4.isOpen = !ctx_r4.isOpen);
    });
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(1, 2, "builders.ui.perform-bulk-action"));
    i0.ɵɵattribute("data-test", "builder-bulk-perform");
  }
}
function ListRendererBulkActionsComponent_cap_button_9_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "cap-button", 13);
    i0.ɵɵlistener("click", function ListRendererBulkActionsComponent_cap_button_9_Template_cap_button_click_0_listener() {
      i0.ɵɵrestoreView(_r7);
      const ctx_r6 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r6.executeAction(ctx_r6.actions[0]));
    });
    i0.ɵɵpipe(1, "async");
    i0.ɵɵpipe(2, "observablePipe");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(1, 3, i0.ɵɵpipeBind1(2, 5, ctx_r2.actions[0].label)))("icon", ctx_r2.actions[0].icon);
    i0.ɵɵattribute("data-test", "builder-bulk-" + ctx_r2.actions[0].key);
  }
}
function ListRendererBulkActionsComponent_ng_container_12_li_1_p_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 20);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const description_r11 = ctx.ngIf;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", description_r11, " ");
  }
}
function ListRendererBulkActionsComponent_ng_container_12_li_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 15);
    i0.ɵɵlistener("click", function ListRendererBulkActionsComponent_ng_container_12_li_1_Template_li_click_0_listener() {
      i0.ɵɵrestoreView(_r14);
      const action_r8 = i0.ɵɵnextContext().$implicit;
      const ctx_r12 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r12.executeAction(action_r8));
    });
    i0.ɵɵelementStart(1, "div", 16);
    i0.ɵɵelement(2, "i");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 17)(4, "p", 18);
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "async");
    i0.ɵɵpipe(7, "observablePipe");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(8, ListRendererBulkActionsComponent_ng_container_12_li_1_p_8_Template, 2, 1, "p", 19);
    i0.ɵɵpipe(9, "async");
    i0.ɵɵpipe(10, "observablePipe");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const action_r8 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵattribute("data-test", (action_r8 == null ? null : action_r8.key) || (action_r8 == null ? null : action_r8.value));
    i0.ɵɵadvance(2);
    i0.ɵɵclassMap(action_r8 == null ? null : action_r8.icon);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(6, 5, i0.ɵɵpipeBind1(7, 7, action_r8 == null ? null : action_r8.label)), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(9, 9, i0.ɵɵpipeBind1(10, 11, action_r8 == null ? null : action_r8.description)));
  }
}
function ListRendererBulkActionsComponent_ng_container_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ListRendererBulkActionsComponent_ng_container_12_li_1_Template, 11, 13, "li", 14);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵpipe(3, "observablePipe");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const action_r8 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(2, 1, i0.ɵɵpipeBind1(3, 3, action_r8 == null ? null : action_r8.hidden)) !== true);
  }
}
const _c3 = function (a0) {
  return {
    amount: a0
  };
};
const _c4 = function (a0) {
  return {
    "row-action__items--open": a0
  };
};
function ListRendererSettingsSidebarComponent_p_tabPanel_2_div_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10)(1, "span", 11);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 1, "search.placeholder"));
  }
}
function ListRendererSettingsSidebarComponent_p_tabPanel_2_ng_container_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
const _c5 = function (a0) {
  return {
    data: a0
  };
};
function ListRendererSettingsSidebarComponent_p_tabPanel_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p-tabPanel", 6);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵelementStart(2, "span", 7);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, ListRendererSettingsSidebarComponent_p_tabPanel_2_div_5_Template, 4, 3, "div", 8);
    i0.ɵɵtemplate(6, ListRendererSettingsSidebarComponent_p_tabPanel_2_ng_container_6_Template, 1, 0, "ng-container", 9);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    const _r2 = i0.ɵɵreference(5);
    i0.ɵɵproperty("header", i0.ɵɵpipeBind1(1, 5, "table.filters"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 7, "table-settings.filters.description"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.globalSearch);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r2)("ngTemplateOutletContext", i0.ɵɵpureFunction1(9, _c5, ctx_r0.filtersData));
  }
}
function ListRendererSettingsSidebarComponent_p_tabPanel_3_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function ListRendererSettingsSidebarComponent_p_tabPanel_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p-tabPanel", 6);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵelementStart(2, "span", 7);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, ListRendererSettingsSidebarComponent_p_tabPanel_3_ng_container_5_Template, 1, 0, "ng-container", 9);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    const _r2 = i0.ɵɵreference(5);
    i0.ɵɵproperty("header", i0.ɵɵpipeBind1(1, 4, "table.columns"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 6, "table-settings.columns.description"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", _r2)("ngTemplateOutletContext", i0.ɵɵpureFunction1(8, _c5, ctx_r1.columnsData));
  }
}
function ListRendererSettingsSidebarComponent_ng_template_4_div_1_div_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵelement(1, "i", 18);
    i0.ɵɵelementEnd();
  }
}
function ListRendererSettingsSidebarComponent_ng_template_4_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 14)(1, "span", 11);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 15);
    i0.ɵɵlistener("click", function ListRendererSettingsSidebarComponent_ng_template_4_div_1_Template_div_click_3_listener() {
      const restoredCtx = i0.ɵɵrestoreView(_r12);
      const item_r9 = restoredCtx.$implicit;
      return i0.ɵɵresetView(item_r9.hidden = !item_r9.hidden);
    });
    i0.ɵɵelement(4, "i");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, ListRendererSettingsSidebarComponent_ng_template_4_div_1_div_5_Template, 2, 0, "div", 16);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r9 = ctx.$implicit;
    i0.ɵɵproperty("cdkDragDisabled", !item_r9.reorderable);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(item_r9.label);
    i0.ɵɵadvance(2);
    i0.ɵɵclassMap(item_r9.hidden ? "fas fa-eye" : "fas fa-eye-slash");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r9.reorderable);
  }
}
function ListRendererSettingsSidebarComponent_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵlistener("cdkDropListDropped", function ListRendererSettingsSidebarComponent_ng_template_4_Template_div_cdkDropListDropped_0_listener($event) {
      const restoredCtx = i0.ɵɵrestoreView(_r14);
      const data_r7 = restoredCtx.data;
      const ctx_r13 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r13.onListReorder($event, data_r7));
    });
    i0.ɵɵtemplate(1, ListRendererSettingsSidebarComponent_ng_template_4_div_1_Template, 6, 5, "div", 13);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const data_r7 = ctx.data;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", data_r7);
  }
}
const _c6 = ["header"];
function CapturumListRendererComponent_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵelement(1, "cpb-list-renderer-header-actions", 17);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("actions", ctx_r0.headerActions);
  }
}
function CapturumListRendererComponent_cpb_list_renderer_filters_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "cpb-list-renderer-filters", 18);
    i0.ɵɵlistener("filterReset", function CapturumListRendererComponent_cpb_list_renderer_filters_4_Template_cpb_list_renderer_filters_filterReset_0_listener() {
      i0.ɵɵrestoreView(_r12);
      const ctx_r11 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r11.handleResetFilter());
    })("filtersChanges", function CapturumListRendererComponent_cpb_list_renderer_filters_4_Template_cpb_list_renderer_filters_filtersChanges_0_listener($event) {
      i0.ɵɵrestoreView(_r12);
      const ctx_r13 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r13.fetchFilters($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("sidebarFiltering", ctx_r2.sidebarFiltering)("config", ctx_r2.filtersConfig)("routeFilters", ctx_r2.saveFiltersInUrl)("filters", ctx_r2.dynamicFilters)("key", ctx_r2.stateKey);
  }
}
function CapturumListRendererComponent_cap_button_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r15 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "cap-button", 19);
    i0.ɵɵlistener("onClick", function CapturumListRendererComponent_cap_button_5_Template_cap_button_onClick_0_listener() {
      i0.ɵɵrestoreView(_r15);
      const ctx_r14 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r14.openTableSettingsSidebar());
    });
    i0.ɵɵelementEnd();
  }
}
const _c7 = function (a0, a1, a2) {
  return {
    tableActions: a0,
    item: a1,
    index: a2
  };
};
function CapturumListRendererComponent_ng_template_9_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementContainer(1, 22);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r21 = i0.ɵɵnextContext();
    const item_r16 = ctx_r21.item;
    const index_r17 = ctx_r21.index;
    const ctx_r18 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r18.tableActionsTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction3(2, _c7, ctx_r18.tableActions, item_r16, index_r17));
  }
}
function CapturumListRendererComponent_ng_template_9_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cap-row-action", 23);
    i0.ɵɵpipe(1, "filterByHiddenExpression");
  }
  if (rf & 2) {
    const item_r16 = i0.ɵɵnextContext().item;
    const ctx_r20 = i0.ɵɵnextContext();
    i0.ɵɵproperty("actions", i0.ɵɵpipeBind2(1, 2, ctx_r20.tableActions, item_r16))("item", item_r16);
  }
}
function CapturumListRendererComponent_ng_template_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, CapturumListRendererComponent_ng_template_9_ng_container_0_Template, 2, 6, "ng-container", 20);
    i0.ɵɵtemplate(1, CapturumListRendererComponent_ng_template_9_ng_template_1_Template, 2, 5, "ng-template", null, 21, i0.ɵɵtemplateRefExtractor);
  }
  if (rf & 2) {
    const _r19 = i0.ɵɵreference(2);
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r5.tableActionsTemplate)("ngIfElse", _r19);
  }
}
function CapturumListRendererComponent_ng_container_10_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cpb-list-renderer-dynamic-widget", 25);
  }
  if (rf & 2) {
    const item_r25 = ctx.item;
    const index_r26 = ctx.index;
    const column_r23 = i0.ɵɵnextContext().$implicit;
    const ctx_r24 = i0.ɵɵnextContext();
    i0.ɵɵproperty("column", column_r23)("index", index_r26)("widget", column_r23 == null ? null : column_r23.columnType)("context", ctx_r24.context)("widgetOptions", column_r23.widget == null ? null : column_r23.widget.options)("item", item_r25);
    i0.ɵɵattribute("data-test", "builder-list-cell-" + index_r26 + "-" + ctx_r24.key);
  }
}
function CapturumListRendererComponent_ng_container_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, CapturumListRendererComponent_ng_container_10_ng_template_1_Template, 1, 7, "ng-template", 24);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const column_r23 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("capTemplate", column_r23.field);
  }
}
function CapturumListRendererComponent_ng_template_11_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
const _c8 = function (a0) {
  return {
    $implicit: a0
  };
};
function CapturumListRendererComponent_ng_template_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, CapturumListRendererComponent_ng_template_11_ng_container_0_Template, 1, 0, "ng-container", 26);
  }
  if (rf & 2) {
    const columns_r28 = ctx.$implicit;
    const ctx_r7 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r7.footerTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c8, columns_r28));
  }
}
function CapturumListRendererComponent_cpb_list_renderer_paginator_12_Template(rf, ctx) {
  if (rf & 1) {
    const _r31 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "cpb-list-renderer-paginator", 27);
    i0.ɵɵlistener("changePage", function CapturumListRendererComponent_cpb_list_renderer_paginator_12_Template_cpb_list_renderer_paginator_changePage_0_listener($event) {
      i0.ɵɵrestoreView(_r31);
      const ctx_r30 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r30.changePage($event));
    })("changePerPage", function CapturumListRendererComponent_cpb_list_renderer_paginator_12_Template_cpb_list_renderer_paginator_changePerPage_0_listener($event) {
      i0.ɵɵrestoreView(_r31);
      const ctx_r32 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r32.changePerPage($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext();
    i0.ɵɵproperty("loading", ctx_r8.loading)("paginator", ctx_r8.paginator)("perPageOptions", ctx_r8.perPageOptions);
  }
}
function CapturumListRendererComponent_cpb_list_renderer_bulk_actions_13_Template(rf, ctx) {
  if (rf & 1) {
    const _r34 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "cpb-list-renderer-bulk-actions", 28);
    i0.ɵɵlistener("cancelSelection", function CapturumListRendererComponent_cpb_list_renderer_bulk_actions_13_Template_cpb_list_renderer_bulk_actions_cancelSelection_0_listener() {
      i0.ɵɵrestoreView(_r34);
      const ctx_r33 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r33.handleCancelSelection());
    })("actionExecuted", function CapturumListRendererComponent_cpb_list_renderer_bulk_actions_13_Template_cpb_list_renderer_bulk_actions_actionExecuted_0_listener() {
      i0.ɵɵrestoreView(_r34);
      const ctx_r35 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r35.handleCancelSelection());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext();
    i0.ɵɵproperty("actions", ctx_r9.bulkActions)("contentTemplate", ctx_r9.bulkActionsTemplate)("selectedItems", ctx_r9.selectedRows);
  }
}
function CapturumListRendererComponent_cap_sidebar_16_Template(rf, ctx) {
  if (rf & 1) {
    const _r37 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "cap-sidebar", 29);
    i0.ɵɵlistener("visibleChange", function CapturumListRendererComponent_cap_sidebar_16_Template_cap_sidebar_visibleChange_0_listener($event) {
      i0.ɵɵrestoreView(_r37);
      const ctx_r36 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r36.showSettingsSidebar = $event);
    });
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵelementStart(2, "cpb-list-renderer-settings-sidebar", 30);
    i0.ɵɵlistener("onSettingsChange", function CapturumListRendererComponent_cap_sidebar_16_Template_cpb_list_renderer_settings_sidebar_onSettingsChange_2_listener($event) {
      i0.ɵɵrestoreView(_r37);
      const ctx_r38 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r38.onSettingsChange($event));
    })("onSidebarClose", function CapturumListRendererComponent_cap_sidebar_16_Template_cpb_list_renderer_settings_sidebar_onSidebarClose_2_listener() {
      i0.ɵɵrestoreView(_r37);
      const ctx_r39 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r39.showSettingsSidebar = false);
    });
    i0.ɵɵpipe(3, "async");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext();
    i0.ɵɵproperty("visible", ctx_r10.showSettingsSidebar)("title", i0.ɵɵpipeBind1(1, 4, "table-settings.title"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("stateKey", ctx_r10.tableSettingsStateKey)("config", i0.ɵɵpipeBind1(3, 6, ctx_r10.config));
  }
}
const _c9 = function (a0, a1) {
  return {
    "header--sticky": a0,
    "d-flex": a1
  };
};
const _c10 = function (a0, a1, a2, a3) {
  return {
    "content--sticky": a0,
    "content--initial-sticky": a1,
    "content--virtual-scroll": a2,
    "table-header--sticky": a3
  };
};
let ListRendererHeaderActionComponent = /*#__PURE__*/(() => {
  class ListRendererHeaderActionComponent {
    constructor(actionService) {
      this.actionService = actionService;
      this.executeAction = new Subject();
    }
    ngOnInit() {
      this.loading$ = merge(this.executeAction, this.actionService.getActionExecutionByActionKey(this.action.key).pipe(map(() => false)));
    }
    handleAction(action) {
      this.executeAction.next(true);
      action.callback();
    }
    static {
      this.ɵfac = function ListRendererHeaderActionComponent_Factory(t) {
        return new (t || ListRendererHeaderActionComponent)(i0.ɵɵdirectiveInject(i1.CapturumBuilderActionService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: ListRendererHeaderActionComponent,
        selectors: [["cpb-list-renderer-header-action"]],
        inputs: {
          action: "action"
        },
        decls: 5,
        vars: 12,
        consts: [["styleClass", "secondary", "capButtonLoading", "", 3, "submitting", "disabled", "label", "icon", "onClick"]],
        template: function ListRendererHeaderActionComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "cap-button", 0);
            i0.ɵɵlistener("onClick", function ListRendererHeaderActionComponent_Template_cap_button_onClick_0_listener() {
              return ctx.handleAction(ctx.action);
            });
            i0.ɵɵpipe(1, "async");
            i0.ɵɵpipe(2, "async");
            i0.ɵɵpipe(3, "translate");
            i0.ɵɵpipe(4, "async");
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("submitting", i0.ɵɵpipeBind1(1, 4, ctx.loading$))("disabled", i0.ɵɵpipeBind1(2, 6, ctx.loading$))("label", i0.ɵɵpipeBind1(3, 8, ctx.action == null ? null : ctx.action.label))("icon", i0.ɵɵpipeBind1(4, 10, ctx.loading$) ? "fas fa-spinner fa-spin" : ctx.action == null ? null : ctx.action.icon);
          }
        },
        dependencies: [i10.CapturumButtonLoadingDirective, i3.CapturumButtonComponent, i1$1.AsyncPipe, i2.TranslatePipe]
      });
    }
  }
  return ListRendererHeaderActionComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ListRendererHeaderActionsComponent = /*#__PURE__*/(() => {
  class ListRendererHeaderActionsComponent {
    constructor() {
      this.actions = [];
    }
    static {
      this.ɵfac = function ListRendererHeaderActionsComponent_Factory(t) {
        return new (t || ListRendererHeaderActionsComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: ListRendererHeaderActionsComponent,
        selectors: [["cpb-list-renderer-header-actions"]],
        inputs: {
          actions: "actions"
        },
        decls: 5,
        vars: 1,
        consts: [[1, "cap-list-renderer-header-actions"], [1, "header-actions-container"], [1, "action-panel"], [1, "header-action__items"], [4, "ngFor", "ngForOf"], [4, "ngIf"], [3, "action"]],
        template: function ListRendererHeaderActionsComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2)(3, "ul", 3);
            i0.ɵɵtemplate(4, ListRendererHeaderActionsComponent_ng_container_4_Template, 4, 5, "ng-container", 4);
            i0.ɵɵelementEnd()()()();
          }
          if (rf & 2) {
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngForOf", ctx.actions);
          }
        },
        dependencies: [i1$1.NgForOf, i1$1.NgIf, ListRendererHeaderActionComponent, i1$1.AsyncPipe, i10.ObservablePipe],
        styles: [".header-action__items[_ngcontent-%COMP%]{display:flex;flex-wrap:wrap;flex-flow:row-reverse}.header-action__items[_ngcontent-%COMP%] > li[_ngcontent-%COMP%]{padding-left:1rem;padding-bottom:1rem}"]
      });
    }
  }
  return ListRendererHeaderActionsComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ListRendererConfigService = /*#__PURE__*/(() => {
  class ListRendererConfigService {
    constructor() {
      this.config = {};
    }
    addConfig(config) {
      if (config) {
        Object.keys(config).filter(key => {
          return key.startsWith('list_');
        }).forEach(key => {
          this.config[key] = config[key];
        });
        if (config.widgets) {
          this.config.widgets = {
            ...this.config.widgets,
            ...config.widgets
          };
        }
        if (config.filters) {
          this.config.filters = Array.from(new Set([...(this.config.filters || []), ...config.filters]));
        }
      }
    }
    static {
      this.ɵfac = function ListRendererConfigService_Factory(t) {
        return new (t || ListRendererConfigService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: ListRendererConfigService,
        factory: ListRendererConfigService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return ListRendererConfigService;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ListRendererActionsService = /*#__PURE__*/(() => {
  class ListRendererActionsService {
    constructor(actionService, listRendererConfigService) {
      this.actionService = actionService;
      this.listRendererConfigService = listRendererConfigService;
    }
    prepareActions(configActions, configurationKey, contextKey) {
      const moduleConfig = this.listRendererConfigService.config?.[configurationKey];
      return configActions?.map(configAction => {
        let additionalProperties = {};
        const moduleActionConfig = moduleConfig?.actions?.[configAction.key];
        if (moduleActionConfig) {
          additionalProperties = {
            hiddenExpression: moduleActionConfig.hiddenExpression ?? false,
            component: moduleActionConfig.component
          };
        }
        return {
          label: configAction.name,
          key: configAction.key,
          icon: configAction.icon,
          callback: item => {
            this.actionService.executeAction({
              key: configAction.key,
              options: configAction.action,
              type: configAction.action.type
            }, item, configurationKey, contextKey);
          },
          ...additionalProperties
        };
      });
    }
    static {
      this.ɵfac = function ListRendererActionsService_Factory(t) {
        return new (t || ListRendererActionsService)(i0.ɵɵinject(i1.CapturumBuilderActionService), i0.ɵɵinject(ListRendererConfigService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: ListRendererActionsService,
        factory: ListRendererActionsService.ɵfac
      });
    }
  }
  return ListRendererActionsService;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ListRendererColumnsService = /*#__PURE__*/(() => {
  class ListRendererColumnsService {
    constructor() {
      this.actionColumn = {
        field: 'actions',
        type: InfoTableColumnType.Actions,
        titleClass: 'cpb-action-header',
        disableSort: true,
        disableRowClick: true
      };
    }
    prepareColumns(configFields) {
      return configFields.map(configField => {
        let type = configField.type;
        if (type === 'template') {
          type = configField?.widget?.name;
        }
        const column = {
          field: configField.column,
          disableSort: !!!configField?.sortable,
          type: configField.type === InfoTableColumnType.Text || !configField.type ? InfoTableColumnType.Text : InfoTableColumnType.Template,
          columnType: type,
          titleClass: configField?.options?.css_class ?? null,
          cellClass: configField?.options?.css_class ?? null,
          hidden: configField?.options?.hidden ?? null,
          options: configField?.options,
          frozen: configField?.options?.frozen ?? null
        };
        if (!!configField?.field) {
          column.sortable = {
            enabled: !!configField?.sortable,
            direction: null,
            field: configField?.field
          };
        }
        if (configField.title) {
          column.title = configField.title;
        }
        if (configField.widget) {
          column.widget = configField.widget;
        }
        if (configField.disableRowClick) {
          column.disableRowClick = configField.disableRowClick;
        }
        return column;
      });
    }
    static {
      this.ɵfac = function ListRendererColumnsService_Factory(t) {
        return new (t || ListRendererColumnsService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: ListRendererColumnsService,
        factory: ListRendererColumnsService.ɵfac
      });
    }
  }
  return ListRendererColumnsService;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const SEARCH_BAR = 'global_search';
let ListRendererFiltersComponent = /*#__PURE__*/(() => {
  class ListRendererFiltersComponent {
    constructor(changeDetectorRef, breakpointObserver, dialogService, translateService) {
      this.changeDetectorRef = changeDetectorRef;
      this.breakpointObserver = breakpointObserver;
      this.dialogService = dialogService;
      this.translateService = translateService;
      this.filtersChanges = new EventEmitter();
      this.onSearch = new EventEmitter();
      this.filterReset = new EventEmitter();
      this.SEARCH_BAR = SEARCH_BAR;
      this.activeFilters = [];
      this.maxTokens = 5;
      this.stackedFilters = false;
      this.destroy$ = new Subject();
      this.handset$ = this.breakpointObserver.observe([Breakpoints.HandsetPortrait, Breakpoints.HandsetLandscape, Breakpoints.TabletPortrait]).pipe(takeUntil(this.destroy$));
    }
    set filtersConfig(value) {
      this.config = value;
      this.stackedFilters = this.config?.show_filters;
    }
    set listFilters(value) {
      if (value !== undefined) {
        // To rerender the dynamic filters component
        if (this.dynamicFilterConfig) {
          this.dynamicFilterConfig = null;
          this.changeDetectorRef.detectChanges();
        }
        this.dynamicFilterConfig = value;
      }
    }
    ngOnDestroy() {
      this.destroy$.next(true);
      this.destroy$.complete();
    }
    refreshList() {
      const formattedFilters = this.getFormattedFilters(this.dynamicFiltersRef?.activeFilters);
      this.filtersChanges.emit(formattedFilters);
    }
    resetFilters() {
      this.filterReset.emit();
    }
    onFilterChange(filters) {
      const formattedFilters = this.getFormattedFilters(filters);
      this.setActiveFilters(filters);
      this.filtersChanges.emit(formattedFilters);
    }
    removeFilter(removedFilter) {
      this.dynamicFiltersRef.handleUpdateValue({
        ...removedFilter,
        value: null
      });
    }
    setActiveFilters(filters) {
      this.activeFilters = filters.filter(filter => filter.field !== SEARCH_BAR);
      this.filteredTokens = this.activeFilters.slice(0, this.maxTokens).map(filter => ({
        ...filter,
        label: this.dynamicFilterConfig?.filters?.find(filterConfig => filterConfig.field === filter.field)?.label
      }));
    }
    getFormattedFilters(filters) {
      const formattedFilters = {};
      filters?.filter(filter => filter.value)?.forEach(filter => formattedFilters[filter.field] = filter.value);
      return formattedFilters;
    }
    static {
      this.ɵfac = function ListRendererFiltersComponent_Factory(t) {
        return new (t || ListRendererFiltersComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1$2.BreakpointObserver), i0.ɵɵdirectiveInject(CapturumDialogService), i0.ɵɵdirectiveInject(i2.TranslateService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: ListRendererFiltersComponent,
        selectors: [["cpb-list-renderer-filters"]],
        viewQuery: function ListRendererFiltersComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(CapturumDynamicFiltersComponent, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.dynamicFiltersRef = _t.first);
          }
        },
        inputs: {
          key: "key",
          routeFilters: "routeFilters",
          sidebarFiltering: "sidebarFiltering",
          filtersConfig: ["config", "filtersConfig"],
          listFilters: ["filters", "listFilters"]
        },
        outputs: {
          filtersChanges: "filtersChanges",
          onSearch: "onSearch",
          filterReset: "filterReset"
        },
        decls: 2,
        vars: 3,
        consts: [[4, "ngIf"], ["class", "filters-label pointer", 3, "click", 4, "ngIf"], [1, "table-filters", "cap-table-filter"], ["hideFilters", ""], ["class", "filters", 3, "global-search-enabled", 4, "ngIf"], [1, "filters-label", "pointer", 3, "click"], [1, "filters"], [3, "filterStyleClass", "containerStyleClass", "storageKey", "routeFilters", "showResetButton", "showRefreshButton", "maxFiltersShown", "sidebarFiltering", "filterConfig", "onResetFilters", "activeFiltersChange"], ["dynamicFiltersComponent", ""]],
        template: function ListRendererFiltersComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, ListRendererFiltersComponent_ng_container_0_Template, 5, 4, "ng-container", 0);
            i0.ɵɵpipe(1, "async");
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.handset$));
          }
        },
        dependencies: [i1$1.NgIf, i4.CapturumDynamicFiltersComponent, i1$1.AsyncPipe, i2.TranslatePipe],
        styles: ["[_ngcontent-%COMP%]:root{--cap-input-height: 30px;--cap-dynamic-filter-input-height: 30px;--cap-dynamic-filter-border-radius: 5px;--cap-dynamic-filter-border-width: 1px;--cap-dynamic-filters-hide-filters-on-mobile: false;--cap-dynamic-filters-filter-flex: 1;--cap-dynamic-filters-flex-wrap: wrap;--cap-dynamic-filter-width: 200px;--cap-dynamic-filter-label-font-size: 14px;--cap-dynamic-filter-label-font-weight: 600;--cap-dynamic-filter-label-font-family: \"Source Sans Pro\";--cap-dynamic-filter-label-font-color: #5f6062;--cap-dynamic-filter-placeholder-font-weight: 600;--cap-dynamic-filter-placeholder-font-color: #5f6062;--cap-dynamic-filter-icon-opacity: 1;--cap-dynamic-filter-icon-color: var(--cap-primary-color)}[_nghost-%COMP%]     cap-validator{display:none}[_nghost-%COMP%]     .filters-label{font-weight:500;font-size:1rem;margin-bottom:.75rem}[_nghost-%COMP%]     .table-filters{display:flex;justify-content:space-between;align-items:center;padding-bottom:.75rem;flex-wrap:wrap}[_nghost-%COMP%]     .table-filters.stacked{align-items:stretch;flex-direction:column}[_nghost-%COMP%]     .table-filters.stacked .filters.handset{padding-right:0}[_nghost-%COMP%]     .table-filters.stacked .filters.handset.global-search-enabled .filter-global{margin-bottom:5px}[_nghost-%COMP%]     .table-filters.stacked .actions .cap-button{width:100%;justify-content:center;display:flex}[_nghost-%COMP%]     .table-filters.stacked .actions .cap-button .p-button-label{flex:0 1 auto}[_nghost-%COMP%]     .table-filters .filters-label{flex-grow:0;padding-right:35px}[_nghost-%COMP%]     .table-filters .filters{padding:0;display:flex;align-items:center;flex:1}[_nghost-%COMP%]     .table-filters .filters.handset{display:block;padding-right:1rem}[_nghost-%COMP%]     .table-filters .filters.handset .table-filters-items{padding-bottom:0}[_nghost-%COMP%]     .table-filters .filters.handset.global-search-enabled .filter-global{padding-bottom:0;margin-bottom:0}[_nghost-%COMP%]     .table-filters.cap-table-filter .resettable-filters cap-input cap-autocomplete .p-inputgroup input.p-inputtext{padding-right:40px!important}[_nghost-%COMP%]     .table-filters .cap-calendar.p-calendar.cap-rounded input, [_nghost-%COMP%]     .table-filters .cap-calendar.p-calendar.cap-rounded input:enabled:hover:not(.p-state-error), [_nghost-%COMP%]     .table-filters .cap-calendar.p-calendar.cap-rounded:hover input, [_nghost-%COMP%]     .table-filters .cap-calendar.p-calendar.cap-rounded:hover input:enabled:hover:not(.p-state-error){border-radius:20px;padding-left:36px}[_nghost-%COMP%]     cap-dropdown.has-icon .p-dropdown .p-dropdown-label{padding-left:35px;padding-top:12px}[_nghost-%COMP%]     cap-dropdown~cpb-list-renderer-reset-filter>.reset-filter{right:40px}[_nghost-%COMP%]     .table-filters-active{flex:1;display:flex;flex-basis:100%;padding-top:.75rem}[_nghost-%COMP%]     .table-filters-active-label{font-size:.75rem;font-weight:600;padding-right:.5rem}[_nghost-%COMP%]     .table-filters-active-token{display:inline}[_nghost-%COMP%]     .table-filters-active .table-filters-tokens{display:inline}[_nghost-%COMP%]     .table-filters-active .table-filters-tokens .p-chips-multiple-container{display:inline;border:0;background-color:transparent;padding:0}[_nghost-%COMP%]     .table-filters-active .table-filters-tokens .p-chips-token{border-radius:16px;padding:.25rem .75rem;margin-bottom:.25rem}[_nghost-%COMP%]     .table-filters-active .table-filters-tokens .p-chips-token-icon{margin-left:.75rem}[_nghost-%COMP%]     .table-filters-active .table-filters-tokens .p-chips-token-icon.pi-times-circle{font-family:\"Font Awesome 5 Pro\";font-weight:400}[_nghost-%COMP%]     .table-filters-active .table-filters-tokens .p-chips-token-icon.pi-times-circle:before{content:\"\\f00d\"}[_nghost-%COMP%]     .table-filters-active .table-filters-tokens .p-chips-input-token{display:none;opacity:0;visibility:hidden;width:0;height:0}[_nghost-%COMP%]     .table-filters-active .table-filters-active-token-more{display:inline-flex;align-items:center}[_nghost-%COMP%]     .table-filters-active .table-filters-active-token-more .dots{line-height:1}[_nghost-%COMP%]     .table-filters-active .table-filters-active-token-more .badge{border-radius:16px;padding:.25rem .75rem;margin-left:.25rem;background-color:var(--cap-primary-color);color:#fff;display:inline-block;height:22px;font-size:.75rem;display:inline-flex;align-items:center}[_nghost-%COMP%]     .filters .filter ::placeholder, [_nghost-%COMP%]     .filters .filter .p-placeholder{color:#5f6062}.cap-checkbox-filter-container[_ngcontent-%COMP%]{height:100%;border-radius:25px;background-color:#fff;display:flex;justify-content:center;flex-direction:column;padding-left:38px}.cap-checkbox-filter-container[_ngcontent-%COMP%]   .cap-checkbox-filter[_ngcontent-%COMP%]{display:flex;justify-content:space-between;color:#b5b5b5}.cap-checkbox-filter-container[_ngcontent-%COMP%]   .cap-checkbox-filter[_ngcontent-%COMP%]   .cap-checkbox-filter-label[_ngcontent-%COMP%]{margin-top:2px;white-space:nowrap;text-overflow:ellipsis;overflow:hidden;display:flex;align-items:center}.cap-checkbox-filter-container[_ngcontent-%COMP%]   .cap-checkbox-filter[_ngcontent-%COMP%]   cap-checkbox[_ngcontent-%COMP%]{display:flex;justify-content:center;flex-direction:column;margin-left:5px}.d-flex[_ngcontent-%COMP%]{display:flex}[_nghost-%COMP%]     .actions{white-space:nowrap;text-align:right;margin-bottom:5px}[_nghost-%COMP%]     .actions cap-button:last-child{margin-left:10px}@media screen and (max-width: 1400px){[_nghost-%COMP%]     .actions{white-space:unset;display:flex;flex-direction:column}[_nghost-%COMP%]     .actions cap-button:last-child{margin-left:0;margin-top:10px}}[_nghost-%COMP%]     .actions.handset.global-search-enabled .cap-button{border-radius:50%;width:33px;height:33px;padding:0;line-height:1;display:flex;align-items:center}[_nghost-%COMP%]     .actions.handset cap-button:last-child{margin-left:0;margin-top:0}"]
      });
    }
  }
  return ListRendererFiltersComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DisplayResetFilterPipe = /*#__PURE__*/(() => {
  class DisplayResetFilterPipe {
    transform(fieldValue) {
      if (fieldValue) {
        if (Array.isArray(fieldValue)) {
          return !!fieldValue?.length;
        }
        return !!String(fieldValue);
      }
      return false;
    }
    static {
      this.ɵfac = function DisplayResetFilterPipe_Factory(t) {
        return new (t || DisplayResetFilterPipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "displayResetFilter",
        type: DisplayResetFilterPipe,
        pure: true
      });
    }
  }
  return DisplayResetFilterPipe;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ListRendererResetFilterComponent = /*#__PURE__*/(() => {
  class ListRendererResetFilterComponent {
    constructor() {
      this.updateForm = new EventEmitter();
    }
    resetFilter() {
      const field = this.form?.get(this.field) || this.form?.controls[this.field];
      if (field) {
        field.reset();
      }
      const value = this.defaultValue || field?.value;
      this.updateForm.emit({
        [this.field]: value
      });
    }
    static {
      this.ɵfac = function ListRendererResetFilterComponent_Factory(t) {
        return new (t || ListRendererResetFilterComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: ListRendererResetFilterComponent,
        selectors: [["cpb-list-renderer-reset-filter"]],
        inputs: {
          form: "form",
          field: "field",
          resetFilterIcon: "resetFilterIcon",
          defaultValue: "defaultValue"
        },
        outputs: {
          updateForm: "updateForm"
        },
        decls: 1,
        vars: 1,
        consts: [[4, "ngIf"], ["class", "reset-filter", 3, "click", 4, "ngIf"], [1, "reset-filter", 3, "click"]],
        template: function ListRendererResetFilterComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, ListRendererResetFilterComponent_ng_container_0_Template, 3, 3, "ng-container", 0);
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.field && (ctx.form == null ? null : ctx.form.value) && ctx.form.value[ctx.field]);
          }
        },
        dependencies: [i1$1.NgIf, DisplayResetFilterPipe],
        encapsulation: 2
      });
    }
  }
  return ListRendererResetFilterComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ListRendererPaginatorComponent = /*#__PURE__*/(() => {
  class ListRendererPaginatorComponent {
    set perPageOptions(value) {
      if (value) {
        this._perPageOptions = value;
      }
    }
    get perPageOptions() {
      return this._perPageOptions;
    }
    get paginator() {
      return this._paginator;
    }
    set paginator(value) {
      this._paginator = value;
      if (value) {
        this.paginatorForm.patchValue({
          perPage: value.per_page,
          page: value.current_page
        }, {
          emitEvent: false
        });
      }
    }
    constructor(formBuilder) {
      this.formBuilder = formBuilder;
      this.changePage = new EventEmitter();
      this.changePerPage = new EventEmitter();
      this.paginatorChanges = new EventEmitter();
      this.destroy$ = new Subject();
      this.paginatorForm = this.formBuilder.group({
        perPage: [null],
        page: [null]
      });
      this._perPageOptions = [10, 20, 50, 100].map(amount => ({
        label: amount.toString(),
        value: amount
      }));
    }
    ngOnInit() {
      this.paginatorForm.valueChanges.pipe(debounceTime(555), takeUntil(this.destroy$)).subscribe(value => this.paginatorChanges.emit(value));
    }
    ngOnDestroy() {
      this.destroy$.next(true);
      this.destroy$.complete();
    }
    static {
      this.ɵfac = function ListRendererPaginatorComponent_Factory(t) {
        return new (t || ListRendererPaginatorComponent)(i0.ɵɵdirectiveInject(i1$3.FormBuilder));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: ListRendererPaginatorComponent,
        selectors: [["cpb-list-renderer-paginator"]],
        inputs: {
          perPageOptions: "perPageOptions",
          paginator: "paginator",
          paginatorForm: "paginatorForm",
          loading: "loading"
        },
        outputs: {
          changePage: "changePage",
          changePerPage: "changePerPage",
          paginatorChanges: "paginatorChanges"
        },
        decls: 9,
        vars: 4,
        consts: [["class", "pagination", 3, "ngClass", "formGroup", 4, "ngIf"], [1, "pagination--skeleton", 3, "ngClass"], [1, "pagination__per-page"], ["width", "58px", "height", "18px"], ["width", "90px", "height", "32px"], ["width", "87px", "height", "18px"], ["width", "240px", "height", "32px"], [1, "pagination", 3, "ngClass", "formGroup"], [1, "pagination__showing"], [1, "pagination__changer"], ["formControlName", "perPage", "sortBy", "value", 3, "sortAlphabetically", "appendTo", "options", "change"], [1, "pagination__entries"], [3, "pagination", "changePage"]],
        template: function ListRendererPaginatorComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, ListRendererPaginatorComponent_div_0_Template, 14, 18, "div", 0);
            i0.ɵɵelementStart(1, "div", 1)(2, "div")(3, "div", 2);
            i0.ɵɵelement(4, "cap-skeleton", 3)(5, "cap-skeleton", 4)(6, "cap-skeleton", 5);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(7, "div");
            i0.ɵɵelement(8, "cap-skeleton", 6);
            i0.ɵɵelementEnd()()();
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.paginatorForm);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c1, ctx.loading));
          }
        },
        dependencies: [i1$1.NgClass, i1$1.NgIf, i3$1.CapturumSkeletonComponent, i4$1.CapturumDropdownComponent, i1$3.NgControlStatus, i1$3.NgControlStatusGroup, i1$3.FormGroupDirective, i1$3.FormControlName, i5.CapturumPaginatorComponent, i2.TranslatePipe],
        styles: [".hidden-section[_ngcontent-%COMP%], .pagination--skeleton[_ngcontent-%COMP%], .pagination--hidden[_ngcontent-%COMP%]{height:0;width:0;overflow:hidden}.pagination[_ngcontent-%COMP%]{display:flex;flex-wrap:wrap;align-items:center;justify-content:space-between}.pagination__per-page[_ngcontent-%COMP%]{display:flex;align-items:center}.pagination__per-page[_ngcontent-%COMP%] > *[_ngcontent-%COMP%]{margin-right:10px}.pagination__per-page[_ngcontent-%COMP%] > *[_ngcontent-%COMP%]:last-child{margin-right:0}.pagination--visible[_ngcontent-%COMP%]{height:auto;width:auto;overflow:visible}.pagination__changer[_ngcontent-%COMP%]{height:40px}"]
      });
    }
  }
  return ListRendererPaginatorComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ComponentHostDirective = /*#__PURE__*/(() => {
  class ComponentHostDirective {
    constructor(viewContainerRef) {
      this.viewContainerRef = viewContainerRef;
    }
    static {
      this.ɵfac = function ComponentHostDirective_Factory(t) {
        return new (t || ComponentHostDirective)(i0.ɵɵdirectiveInject(i0.ViewContainerRef));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: ComponentHostDirective,
        selectors: [["", "cpbComponentHost", ""]]
      });
    }
  }
  return ComponentHostDirective;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// tslint:disable-next-line:directive-class-suffix
let ListRendererWidgetBase = /*#__PURE__*/(() => {
  class ListRendererWidgetBase {
    constructor() {
      this.item = {};
      this.context = {};
    }
    static {
      this.ɵfac = function ListRendererWidgetBase_Factory(t) {
        return new (t || ListRendererWidgetBase)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: ListRendererWidgetBase,
        inputs: {
          item: "item",
          index: "index",
          field: "field",
          context: "context",
          column: "column"
        }
      });
    }
  }
  return ListRendererWidgetBase;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ConcatenatePipe = /*#__PURE__*/(() => {
  class ConcatenatePipe {
    transform(value, properties) {
      if (properties) {
        return properties.reduce((acc, item) => {
          acc += value[item] ? value[item] + ' ' : '';
          return acc;
        }, '').trim();
      }
      return value;
    }
    static {
      this.ɵfac = function ConcatenatePipe_Factory(t) {
        return new (t || ConcatenatePipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "concatenate",
        type: ConcatenatePipe,
        pure: true
      });
    }
  }
  return ConcatenatePipe;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ListRendererWidgetConcatenationComponent = /*#__PURE__*/(() => {
  class ListRendererWidgetConcatenationComponent extends ListRendererWidgetBase {
    static {
      this.ɵfac = /* @__PURE__ */function () {
        let ɵListRendererWidgetConcatenationComponent_BaseFactory;
        return function ListRendererWidgetConcatenationComponent_Factory(t) {
          return (ɵListRendererWidgetConcatenationComponent_BaseFactory || (ɵListRendererWidgetConcatenationComponent_BaseFactory = i0.ɵɵgetInheritedFactory(ListRendererWidgetConcatenationComponent)))(t || ListRendererWidgetConcatenationComponent);
        };
      }();
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: ListRendererWidgetConcatenationComponent,
        selectors: [["cpb-list-renderer-widget-concatenation"]],
        inputs: {
          parts: "parts"
        },
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 1,
        vars: 1,
        consts: [[4, "ngIf"]],
        template: function ListRendererWidgetConcatenationComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, ListRendererWidgetConcatenationComponent_div_0_Template, 3, 4, "div", 0);
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.item);
          }
        },
        dependencies: [i1$1.NgIf, ConcatenatePipe],
        encapsulation: 2
      });
    }
  }
  return ListRendererWidgetConcatenationComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ListRendererWidgetImageComponent = /*#__PURE__*/(() => {
  class ListRendererWidgetImageComponent extends ListRendererWidgetBase {
    constructor() {
      super(...arguments);
      this.shape = 'square';
    }
    static {
      this.ɵfac = /* @__PURE__ */function () {
        let ɵListRendererWidgetImageComponent_BaseFactory;
        return function ListRendererWidgetImageComponent_Factory(t) {
          return (ɵListRendererWidgetImageComponent_BaseFactory || (ɵListRendererWidgetImageComponent_BaseFactory = i0.ɵɵgetInheritedFactory(ListRendererWidgetImageComponent)))(t || ListRendererWidgetImageComponent);
        };
      }();
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: ListRendererWidgetImageComponent,
        selectors: [["cpb-list-renderer-widget-image"]],
        inputs: {
          shape: "shape"
        },
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 1,
        vars: 1,
        consts: [[3, "class", 4, "ngIf"], ["alt", "widget-image", 3, "src"]],
        template: function ListRendererWidgetImageComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, ListRendererWidgetImageComponent_div_0_Template, 2, 4, "div", 0);
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.item);
          }
        },
        dependencies: [i1$1.NgIf],
        styles: [".list-renderer-widget-image[_ngcontent-%COMP%]{height:45px;width:45px}.list-renderer-widget-image--square[_ngcontent-%COMP%]{border-radius:4px}.list-renderer-widget-image--square[_ngcontent-%COMP%] > img[_ngcontent-%COMP%]{border-radius:4px}.list-renderer-widget-image--circle[_ngcontent-%COMP%]{border-radius:50%}.list-renderer-widget-image--circle[_ngcontent-%COMP%] > img[_ngcontent-%COMP%]{border-radius:50%}.list-renderer-widget-image[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{width:100%;height:100%;object-fit:cover}"]
      });
    }
  }
  return ListRendererWidgetImageComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var LinkHrefType = /*#__PURE__*/function (LinkHrefType) {
  LinkHrefType["Phone"] = "tel:";
  LinkHrefType["Email"] = "mailto:";
  LinkHrefType["Sms"] = "sms:";
  LinkHrefType["Fax"] = "fax:";
  return LinkHrefType;
}(LinkHrefType || {});
let ListRendererWidgetLinkComponent = /*#__PURE__*/(() => {
  class ListRendererWidgetLinkComponent extends ListRendererWidgetBase {
    constructor() {
      super(...arguments);
      this.target = '_blank';
      this.LinkHrefType = LinkHrefType;
    }
    static {
      this.ɵfac = /* @__PURE__ */function () {
        let ɵListRendererWidgetLinkComponent_BaseFactory;
        return function ListRendererWidgetLinkComponent_Factory(t) {
          return (ɵListRendererWidgetLinkComponent_BaseFactory || (ɵListRendererWidgetLinkComponent_BaseFactory = i0.ɵɵgetInheritedFactory(ListRendererWidgetLinkComponent)))(t || ListRendererWidgetLinkComponent);
        };
      }();
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: ListRendererWidgetLinkComponent,
        selectors: [["cpb-list-renderer-widget-link"]],
        inputs: {
          type: "type",
          target: "target"
        },
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 1,
        vars: 1,
        consts: [[3, "target", "href", 4, "ngIf"], [3, "target", "href"]],
        template: function ListRendererWidgetLinkComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, ListRendererWidgetLinkComponent_a_0_Template, 2, 3, "a", 0);
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.item[ctx.field]);
          }
        },
        dependencies: [i1$1.NgIf],
        encapsulation: 2
      });
    }
  }
  return ListRendererWidgetLinkComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ListRendererWidgetBaseDataComponent = /*#__PURE__*/(() => {
  class ListRendererWidgetBaseDataComponent extends ListRendererWidgetBase {
    constructor() {
      super(...arguments);
      this.default = '-';
    }
    static {
      this.ɵfac = /* @__PURE__ */function () {
        let ɵListRendererWidgetBaseDataComponent_BaseFactory;
        return function ListRendererWidgetBaseDataComponent_Factory(t) {
          return (ɵListRendererWidgetBaseDataComponent_BaseFactory || (ɵListRendererWidgetBaseDataComponent_BaseFactory = i0.ɵɵgetInheritedFactory(ListRendererWidgetBaseDataComponent)))(t || ListRendererWidgetBaseDataComponent);
        };
      }();
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: ListRendererWidgetBaseDataComponent,
        selectors: [["cpb-list-renderer-widget-base-data"]],
        inputs: {
          default: "default"
        },
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 3,
        vars: 3,
        template: function ListRendererWidgetBaseDataComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "p");
            i0.ɵɵtext(1);
            i0.ɵɵpipe(2, "translate");
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance(1);
            i0.ɵɵtextInterpolate1(" ", ctx.item && ctx.field && ctx.item[ctx.field] ? i0.ɵɵpipeBind1(2, 1, "base-data." + ctx.item[ctx.field]) : ctx.default, " ");
          }
        },
        dependencies: [i2.TranslatePipe],
        encapsulation: 2
      });
    }
  }
  return ListRendererWidgetBaseDataComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ListRendererWidgetBooleanComponent = /*#__PURE__*/(() => {
  class ListRendererWidgetBooleanComponent extends ListRendererWidgetBase {
    constructor() {
      super(...arguments);
      this.default = '-';
    }
    static {
      this.ɵfac = /* @__PURE__ */function () {
        let ɵListRendererWidgetBooleanComponent_BaseFactory;
        return function ListRendererWidgetBooleanComponent_Factory(t) {
          return (ɵListRendererWidgetBooleanComponent_BaseFactory || (ɵListRendererWidgetBooleanComponent_BaseFactory = i0.ɵɵgetInheritedFactory(ListRendererWidgetBooleanComponent)))(t || ListRendererWidgetBooleanComponent);
        };
      }();
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: ListRendererWidgetBooleanComponent,
        selectors: [["cpb-list-renderer-widget-boolean"]],
        inputs: {
          default: "default"
        },
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 3,
        vars: 3,
        template: function ListRendererWidgetBooleanComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "p");
            i0.ɵɵtext(1);
            i0.ɵɵpipe(2, "translate");
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance(1);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, !!ctx.item[ctx.field] ? "general.yes" : "general.no"), " ");
          }
        },
        dependencies: [i2.TranslatePipe],
        encapsulation: 2
      });
    }
  }
  return ListRendererWidgetBooleanComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ListRendererWidgetsService = /*#__PURE__*/(() => {
  class ListRendererWidgetsService {
    constructor(listRendererConfigService, componentFactoryResolver) {
      this.listRendererConfigService = listRendererConfigService;
      this.componentFactoryResolver = componentFactoryResolver;
      this.widgets = {
        image: ListRendererWidgetImageComponent,
        link: ListRendererWidgetLinkComponent,
        fullName: ListRendererWidgetConcatenationComponent,
        baseData: ListRendererWidgetBaseDataComponent,
        ['base-data-value']: ListRendererWidgetBaseDataComponent,
        boolean: ListRendererWidgetBooleanComponent
      };
      this.widgets = {
        ...this.widgets,
        ...this.listRendererConfigService.config?.widgets
      };
    }
    loadWidget(viewContainerRef, component, data) {
      viewContainerRef.clear();
      const widgetComponent = viewContainerRef.createComponent(this.componentFactoryResolver.resolveComponentFactory(component));
      if (data) {
        Object.keys(data).forEach(key => {
          widgetComponent.instance[key] = data[key];
        });
      }
      return widgetComponent;
    }
    static {
      this.ɵfac = function ListRendererWidgetsService_Factory(t) {
        return new (t || ListRendererWidgetsService)(i0.ɵɵinject(ListRendererConfigService), i0.ɵɵinject(i0.ComponentFactoryResolver));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: ListRendererWidgetsService,
        factory: ListRendererWidgetsService.ɵfac
      });
    }
  }
  return ListRendererWidgetsService;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ListRendererDynamicWidgetComponent = /*#__PURE__*/(() => {
  class ListRendererDynamicWidgetComponent {
    constructor(listBuilderWidgetsService) {
      this.listBuilderWidgetsService = listBuilderWidgetsService;
    }
    get item() {
      return this._item;
    }
    set item(value) {
      this._item = value;
      if (value) {
        this.loadWidgetComponent();
      }
    }
    ngOnChanges(changes) {
      if (this.widget && this.item && !this.widgetLoaded) {
        this.loadWidgetComponent();
        this.widgetLoaded = true;
      } else if (!!changes?.context?.currentValue && this.widgetLoaded) {
        this.loadWidgetComponent();
      }
    }
    loadWidgetComponent() {
      if (this.listBuilderWidgetsService.widgets[this.widget]) {
        this.listBuilderWidgetsService.loadWidget(this.componentHost.viewContainerRef, this.listBuilderWidgetsService.widgets[this.widget], {
          item: this.item,
          field: this.column.field,
          context: this.context,
          index: this.index,
          column: this.column,
          ...this.widgetOptions
        });
      }
    }
    static {
      this.ɵfac = function ListRendererDynamicWidgetComponent_Factory(t) {
        return new (t || ListRendererDynamicWidgetComponent)(i0.ɵɵdirectiveInject(ListRendererWidgetsService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: ListRendererDynamicWidgetComponent,
        selectors: [["cpb-list-renderer-dynamic-widget"]],
        viewQuery: function ListRendererDynamicWidgetComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(ComponentHostDirective, 7);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.componentHost = _t.first);
          }
        },
        inputs: {
          column: "column",
          index: "index",
          widget: "widget",
          widgetOptions: "widgetOptions",
          context: "context",
          item: "item"
        },
        features: [i0.ɵɵNgOnChangesFeature],
        decls: 1,
        vars: 0,
        consts: [["cpbComponentHost", ""]],
        template: function ListRendererDynamicWidgetComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, ListRendererDynamicWidgetComponent_ng_template_0_Template, 0, 0, "ng-template", 0);
          }
        },
        dependencies: [ComponentHostDirective],
        encapsulation: 2
      });
    }
  }
  return ListRendererDynamicWidgetComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ListRendererFiltersService = /*#__PURE__*/(() => {
  class ListRendererFiltersService {
    constructor() {
      this.filterStateKey = `list-renderer-filter`;
    }
    prepareFilters(configFilters) {
      return configFilters.map(configFilter => {
        return {
          field: configFilter.name,
          type: configFilter.type,
          options: configFilter.options,
          placeholder: configFilter.placeholder,
          label: configFilter.label,
          icon: configFilter.icon,
          matchMode: configFilter.operator,
          autoDisplayFirst: configFilter.autoDisplayFirst,
          defaultValue: configFilter.default
        };
      }).map(item => this.extractFilledProperty(item));
    }
    getActiveFilters(listKey) {
      return JSON.parse(localStorage.getItem(this.getFilterStateKey(listKey)));
    }
    setFilterState(key, filters) {
      localStorage.setItem(this.getFilterStateKey(key), JSON.stringify(filters));
    }
    clearFilterState(listKey) {
      localStorage.removeItem(this.getFilterStateKey(listKey));
    }
    getFilterStateKey(listKey) {
      return `${this.filterStateKey}-${listKey}`;
    }
    extractFilledProperty(item) {
      return Object.keys(item).reduce((acc, key) => {
        if (item[key]) {
          acc[key] = item[key];
        }
        return acc;
      }, {});
    }
    static {
      this.ɵfac = function ListRendererFiltersService_Factory(t) {
        return new (t || ListRendererFiltersService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: ListRendererFiltersService,
        factory: ListRendererFiltersService.ɵfac
      });
    }
  }
  return ListRendererFiltersService;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var ListRendererBreakpoints = /*#__PURE__*/function (ListRendererBreakpoints) {
  ListRendererBreakpoints["mobile"] = "mobile";
  ListRendererBreakpoints["tablet"] = "tablet";
  ListRendererBreakpoints["desktop"] = "desktop";
  return ListRendererBreakpoints;
}(ListRendererBreakpoints || {});
var HeaderType = /*#__PURE__*/function (HeaderType) {
  HeaderType["Sticky"] = "sticky";
  HeaderType["Static"] = "static";
  return HeaderType;
}(HeaderType || {});
var ListRendererActionType = /*#__PURE__*/function (ListRendererActionType) {
  ListRendererActionType["dotMenu"] = "dot_menu";
  ListRendererActionType["bulkAction"] = "bulk_action";
  ListRendererActionType["onRowClick"] = "on_row_click";
  ListRendererActionType["onColumnClick"] = "on_column_click";
  ListRendererActionType["headerButton"] = "header_button";
  ListRendererActionType["drop"] = "drop";
  return ListRendererActionType;
}(ListRendererActionType || {});
var PaginationType = /*#__PURE__*/function (PaginationType) {
  PaginationType["Paginated"] = "paginated";
  PaginationType["InfiniteScroll"] = "infinite";
  PaginationType["VirtualScroll"] = "virtual";
  return PaginationType;
}(PaginationType || {});
let SetListConfiguration = /*#__PURE__*/(() => {
  class SetListConfiguration {
    static {
      this.type = '[ListRenderer] Set list configuration';
    }
    constructor(key, configuration) {
      this.key = key;
      this.configuration = configuration;
    }
  }
  return SetListConfiguration;
})();
class GetListConfigurationByKey {}

// @dynamic
class ListRendererUtils {
  static setApiOptions(apiOptions, options, filterConfigs) {
    // Removing global_search from filters
    const filters = {
      ...options
    };
    delete filters[SEARCH_BAR];
    return {
      ...apiOptions,
      filters: Object.keys(filters)
      // Adjust form value for API filters
      .map(key => {
        const config = filterConfigs.find(filterConfig => filterConfig.name === key);
        let value = ListRendererUtils.prepareFiltersValue(filters[key], config);
        let operator = config?.operator || FilterMatchMode.LIKE;
        return {
          field: key,
          value: value,
          operator: operator
        };
      })
      // Exclude empty filters
      .filter(filter => {
        if (Array.isArray(filter.value)) {
          return !!filter.value && filter?.value?.length;
        }
        return filter.value !== null && typeof filter.value !== 'undefined';
      })
      // Add percentage for LIKE operator
      .map(filter => {
        if (filter.operator === FilterMatchMode.LIKE) {
          filter.value = `%${filter.value}%`;
        }
        return filter;
      }),
      search: options?.[SEARCH_BAR] ? [options[SEARCH_BAR]] : null
    };
  }
  static prepareFiltersValue(value, filter) {
    if (!value || !filter) {
      return value;
    }
    switch (filter.type) {
      case InputType.date:
        if (filter.options?.timezone) {
          if (filter.operator === FilterMatchMode.BETWEEN || filter.operator === FilterMatchMode.DATEBETWEEN) {
            return DateHelper.getRange(value);
          }
          return DateHelper.getStartOfDay(value);
        }
        return value;
      default:
        return value;
    }
  }
  static generateQueryUrlFilters(filters) {
    let queryParams = {};
    Object.keys(filters).forEach(filterKey => {
      let value = filters[filterKey];
      if (Array.isArray(value)) {
        value = value.join(',');
      }
      queryParams = {
        ...queryParams,
        [`[filters][${filterKey}]`]: value
      };
    });
    return queryParams;
  }
}
let ListRendererApiService = /*#__PURE__*/(() => {
  class ListRendererApiService extends ApiService {
    /**
     * This redundant things resolve error described in this PR
     * PR - https://bitbucket.org/deindruksoftware/capturum-builders/pull-requests/59/fix-add-constructor-to-avoid-error
     */
    constructor(apiHttp, builderApiService, sessionStorageService, contextService) {
      super(apiHttp);
      this.apiHttp = apiHttp;
      this.builderApiService = builderApiService;
      this.sessionStorageService = sessionStorageService;
      this.contextService = contextService;
      this.endpoint = 'builder/config';
    }
    data(path, key, options) {
      let url = path;
      if (options) {
        url += this.getOptionsQuery(options);
      }
      return this.builderApiService.get(key, url);
    }
    getConfig(contextKey, key) {
      const currentContext = this.contextService.getContextByKey(contextKey);
      const listConfig = this.sessionStorageService.getItem(`list_config_${key}`);
      if (listConfig && listConfig.config && (!listConfig.context && !currentContext || this.areObjectsEqual(listConfig?.context, currentContext))) {
        return of(listConfig.config);
      }
      return this.builderApiService.get(contextKey, `/${this.endpoint}/${key}`).pipe(responseData, tap(config => {
        if (config.options?.cache) {
          this.sessionStorageService.setItem(`list_config_${key}`, {
            config: config,
            context: currentContext
          });
        }
      }));
    }
    areObjectsEqual(object1, object2) {
      return object1 && object2 && Object.keys(object1).length === Object.keys(object2).length && Object.keys(object1).every(key => object1[key] === object2[key]);
    }
    static {
      this.ɵfac = function ListRendererApiService_Factory(t) {
        return new (t || ListRendererApiService)(i0.ɵɵinject(i1$4.ApiHttpService), i0.ɵɵinject(i1.BuilderApiService), i0.ɵɵinject(i10.SessionStorageService), i0.ɵɵinject(i1.CapturumBuildersContextService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: ListRendererApiService,
        factory: ListRendererApiService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return ListRendererApiService;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var ListRendererState_1;
let ListRendererState = class ListRendererState {
  static {
    ListRendererState_1 = this;
  }
  static configurationByKey(key) {
    return createSelector([ListRendererState_1], state => {
      return state.configurations[key];
    });
  }
  setFormConfiguration(ctx, {
    key,
    configuration
  }) {
    const state = ctx.getState();
    ctx.setState({
      ...state,
      configurations: {
        ...state.configurations,
        [key]: configuration
      }
    });
  }
  static {
    this.ɵfac = function ListRendererState_Factory(t) {
      return new (t || ListRendererState)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: ListRendererState,
      factory: ListRendererState.ɵfac
    });
  }
};
__decorate([Action(SetListConfiguration)], ListRendererState.prototype, "setFormConfiguration", null);
ListRendererState = ListRendererState_1 = __decorate([State({
  name: 'listRenderer',
  defaults: {
    configurations: {}
  }
})], ListRendererState);
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ListRendererService = /*#__PURE__*/(() => {
  class ListRendererService {
    constructor(store) {
      this.store = store;
      this._refreshTable = new Subject();
    }
    getRefreshTable() {
      return this._refreshTable.asObservable();
    }
    refreshTable() {
      this._refreshTable.next();
    }
    getListConfigByKey(key) {
      return this.store.select(ListRendererState.configurationByKey(key)).pipe(take(1));
    }
    static {
      this.ɵfac = function ListRendererService_Factory(t) {
        return new (t || ListRendererService)(i0.ɵɵinject(i1$5.Store));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: ListRendererService,
        factory: ListRendererService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return ListRendererService;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ListRendererBulkActionsComponent = /*#__PURE__*/(() => {
  class ListRendererBulkActionsComponent {
    constructor() {
      this.isOpen = false;
      this.actions = [];
      this.selectedItems = [];
      this.cancelSelection = new EventEmitter();
      this.actionExecuted = new EventEmitter();
    }
    executeAction(action) {
      action.callback(this.selectedItems);
      this.actionExecuted.emit();
    }
    handleCancelSelection() {
      this.cancelSelection.emit();
    }
    static {
      this.ɵfac = function ListRendererBulkActionsComponent_Factory(t) {
        return new (t || ListRendererBulkActionsComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: ListRendererBulkActionsComponent,
        selectors: [["cpb-list-renderer-bulk-actions"]],
        inputs: {
          actions: "actions",
          selectedItems: "selectedItems",
          contentTemplate: "contentTemplate"
        },
        outputs: {
          cancelSelection: "cancelSelection",
          actionExecuted: "actionExecuted"
        },
        decls: 13,
        vars: 17,
        consts: [[1, "cap-list-renderer-bulk-actions"], [1, "bulk-action-title"], ["class", "bulk-action-content", 4, "ngIf"], [1, "button-container"], ["styleClass", "secondary", 3, "label", "click"], ["styleClass", "primary", 3, "label", "click", 4, "ngIf"], ["styleClass", "primary", 3, "label", "icon", "click", 4, "ngIf"], [1, "action-panel"], [1, "row-action__items", "bulk-items", 3, "ngClass"], [4, "ngFor", "ngForOf"], [1, "bulk-action-content"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], ["styleClass", "primary", 3, "label", "click"], ["styleClass", "primary", 3, "label", "icon", "click"], [3, "click", 4, "ngIf"], [3, "click"], [1, "row-action__icon"], [1, "row-action__info"], [1, "title"], ["class", "description", 4, "ngIf"], [1, "description"]],
        template: function ListRendererBulkActionsComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
            i0.ɵɵtext(2);
            i0.ɵɵpipe(3, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(4, ListRendererBulkActionsComponent_div_4_Template, 2, 4, "div", 2);
            i0.ɵɵelementStart(5, "div", 3)(6, "cap-button", 4);
            i0.ɵɵlistener("click", function ListRendererBulkActionsComponent_Template_cap_button_click_6_listener() {
              return ctx.handleCancelSelection();
            });
            i0.ɵɵpipe(7, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(8, ListRendererBulkActionsComponent_cap_button_8_Template, 2, 4, "cap-button", 5);
            i0.ɵɵtemplate(9, ListRendererBulkActionsComponent_cap_button_9_Template, 3, 7, "cap-button", 6);
            i0.ɵɵelementStart(10, "div", 7)(11, "ul", 8);
            i0.ɵɵtemplate(12, ListRendererBulkActionsComponent_ng_container_12_Template, 4, 5, "ng-container", 9);
            i0.ɵɵelementEnd()()()();
          }
          if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(3, 8, "builders.ui.rows-selected", i0.ɵɵpureFunction1(13, _c3, ctx.selectedItems.length)), " ");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.contentTemplate);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("label", i0.ɵɵpipeBind1(7, 11, "builders.ui.cancel-selection"));
            i0.ɵɵattribute("data-test", "builder-bulk-cancel");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.actions.length > 1);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.actions.length === 1);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(15, _c4, ctx.isOpen));
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngForOf", ctx.actions);
          }
        },
        dependencies: [i1$1.NgClass, i1$1.NgForOf, i1$1.NgIf, i1$1.NgTemplateOutlet, i3.CapturumButtonComponent, i1$1.AsyncPipe, i10.ObservablePipe, i2.TranslatePipe],
        styles: ["[_ngcontent-%COMP%]:root{--cap-input-height: 30px;--cap-dynamic-filter-input-height: 30px;--cap-dynamic-filter-border-radius: 5px;--cap-dynamic-filter-border-width: 1px;--cap-dynamic-filters-hide-filters-on-mobile: false;--cap-dynamic-filters-filter-flex: 1;--cap-dynamic-filters-flex-wrap: wrap;--cap-dynamic-filter-width: 200px;--cap-dynamic-filter-label-font-size: 14px;--cap-dynamic-filter-label-font-weight: 600;--cap-dynamic-filter-label-font-family: \"Source Sans Pro\";--cap-dynamic-filter-label-font-color: #5f6062;--cap-dynamic-filter-placeholder-font-weight: 600;--cap-dynamic-filter-placeholder-font-color: #5f6062;--cap-dynamic-filter-icon-opacity: 1;--cap-dynamic-filter-icon-color: var(--cap-primary-color)}.cap-list-renderer-bulk-actions[_ngcontent-%COMP%]{position:sticky;display:flex;justify-content:space-between;bottom:0;left:0;right:0;background:#fff;padding:15px;border:1px solid #ddd;border-radius:5px 5px 3px 3px}.cap-list-renderer-bulk-actions[_ngcontent-%COMP%]   .action-panel[_ngcontent-%COMP%]{position:absolute;bottom:100px;right:0;background:#fff}.cap-list-renderer-bulk-actions[_ngcontent-%COMP%]   .action-panel[_ngcontent-%COMP%]   .row-action__items[_ngcontent-%COMP%]{bottom:-50px;width:unset;min-width:200px}.cap-list-renderer-bulk-actions[_ngcontent-%COMP%]   .bulk-action-title[_ngcontent-%COMP%]{color:#7a7a7a;display:flex;flex-direction:column;justify-content:center}.cap-list-renderer-bulk-actions[_ngcontent-%COMP%]   .bulk-action-content[_ngcontent-%COMP%]{padding:15px;flex:1}.cap-list-renderer-bulk-actions[_ngcontent-%COMP%]   .button-container[_ngcontent-%COMP%]{position:relative;display:flex;justify-content:end;width:50%}.cap-list-renderer-bulk-actions[_ngcontent-%COMP%]   .button-container[_ngcontent-%COMP%] > cap-button[_ngcontent-%COMP%]:not(:last-child){margin-right:15px}ul.bulk-items[_ngcontent-%COMP%]:before{display:none}.bulk-items[_ngcontent-%COMP%]:after{content:\"\";margin:0 .5em;display:inline-block;border:7px solid transparent;border-top:8px solid #fff;border-bottom:0 none;position:absolute;right:30px}"]
      });
    }
  }
  return ListRendererBulkActionsComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ListRendererSettingsSidebarComponent = /*#__PURE__*/(() => {
  class ListRendererSettingsSidebarComponent {
    constructor(localStorage, toastService, translateService) {
      this.localStorage = localStorage;
      this.toastService = toastService;
      this.translateService = translateService;
      this.onSettingsChange = new EventEmitter();
      this.onSidebarClose = new EventEmitter();
    }
    ngOnInit() {
      const localStorageSettings = this.localStorage.getItem(this.stateKey);
      this.columnsData = localStorageSettings?.columns || this.config?.columns?.filter(column => {
        return column.type !== InfoTableColumnType.Actions && column.type !== InfoTableColumnType.EditButtons;
      })?.map(column => {
        return {
          field: column.column,
          label: `${column.title || ''}`,
          reorderable: false,
          hidden: false
        };
      });
      if (this.config?.filters?.global_search?.enabled) {
        this.globalSearch = true;
      }
      this.filtersData = localStorageSettings?.filters || this.config?.filters?.fields?.map(filter => {
        return {
          field: filter.name,
          label: filter.label || '',
          reorderable: true,
          hidden: false
        };
      });
    }
    onListReorder(event, list) {
      moveItemInArray(list, event.previousIndex, event.currentIndex);
    }
    applySettingsChanges() {
      const visibleColumns = this.columnsData.filter(column => !column.hidden);
      if (visibleColumns.length === 0) {
        this.toastService.warning(this.translateService.instant('toast.warning.title'), this.translateService.instant('table-settings.columns.choose-one-column.warning'));
        return;
      }
      this.onSettingsChange.emit({
        filters: this.filtersData,
        columns: this.columnsData
      });
    }
    cancel() {
      this.onSidebarClose.emit();
    }
    static {
      this.ɵfac = function ListRendererSettingsSidebarComponent_Factory(t) {
        return new (t || ListRendererSettingsSidebarComponent)(i0.ɵɵdirectiveInject(i10.LocalStorageService), i0.ɵɵdirectiveInject(i10.ToastService), i0.ɵɵdirectiveInject(i2.TranslateService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: ListRendererSettingsSidebarComponent,
        selectors: [["cpb-list-renderer-settings-sidebar"]],
        inputs: {
          config: "config",
          stateKey: "stateKey"
        },
        outputs: {
          onSettingsChange: "onSettingsChange",
          onSidebarClose: "onSidebarClose"
        },
        decls: 11,
        vars: 8,
        consts: [[1, "list-renderer-settings-sidebar"], [3, "header", 4, "ngIf"], ["settingsList", ""], [1, "sidebar-settings-buttons"], ["styleClass", "secondary", 3, "label", "onClick"], ["styleClass", "success", "icon", "fas fa-check", 3, "label", "onClick"], [3, "header"], [1, "placeholder-text"], ["class", "settings-list-items__item d-flex align-items-center mb-2", 4, "ngIf"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "settings-list-items__item", "d-flex", "align-items-center", "mb-2"], [1, "flex-1"], ["cdkDropList", "", 1, "settings-list-items", 3, "cdkDropListDropped"], ["class", "settings-list-items__item d-flex align-items-center mb-2", "cdkDragBoundary", ".cap-sidebar-content", "cdkDrag", "", 3, "cdkDragDisabled", 4, "ngFor", "ngForOf"], ["cdkDragBoundary", ".cap-sidebar-content", "cdkDrag", "", 1, "settings-list-items__item", "d-flex", "align-items-center", "mb-2", 3, "cdkDragDisabled"], [1, "hide-handle", 3, "click"], ["class", "drag-handle", "cdkDragHandle", "", 4, "ngIf"], ["cdkDragHandle", "", 1, "drag-handle"], [1, "fas", "fa-arrows-v"]],
        template: function ListRendererSettingsSidebarComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "p-tabView");
            i0.ɵɵtemplate(2, ListRendererSettingsSidebarComponent_p_tabPanel_2_Template, 7, 11, "p-tabPanel", 1);
            i0.ɵɵtemplate(3, ListRendererSettingsSidebarComponent_p_tabPanel_3_Template, 6, 10, "p-tabPanel", 1);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(4, ListRendererSettingsSidebarComponent_ng_template_4_Template, 2, 1, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵelementStart(6, "div", 3)(7, "cap-button", 4);
            i0.ɵɵlistener("onClick", function ListRendererSettingsSidebarComponent_Template_cap_button_onClick_7_listener() {
              return ctx.cancel();
            });
            i0.ɵɵpipe(8, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(9, "cap-button", 5);
            i0.ɵɵlistener("onClick", function ListRendererSettingsSidebarComponent_Template_cap_button_onClick_9_listener() {
              return ctx.applySettingsChanges();
            });
            i0.ɵɵpipe(10, "translate");
            i0.ɵɵelementEnd()()();
          }
          if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.filtersData);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.columnsData);
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("label", i0.ɵɵpipeBind1(8, 4, "button.cancel"));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("label", i0.ɵɵpipeBind1(10, 6, "apply.button"));
          }
        },
        dependencies: [i1$1.NgForOf, i1$1.NgIf, i1$1.NgTemplateOutlet, i3.CapturumButtonComponent, i5$1.TabView, i5$1.TabPanel, i6.CdkDropList, i6.CdkDrag, i6.CdkDragHandle, i2.TranslatePipe],
        styles: [":root{--cap-input-height: 30px;--cap-dynamic-filter-input-height: 30px;--cap-dynamic-filter-border-radius: 5px;--cap-dynamic-filter-border-width: 1px;--cap-dynamic-filters-hide-filters-on-mobile: false;--cap-dynamic-filters-filter-flex: 1;--cap-dynamic-filters-flex-wrap: wrap;--cap-dynamic-filter-width: 200px;--cap-dynamic-filter-label-font-size: 14px;--cap-dynamic-filter-label-font-weight: 600;--cap-dynamic-filter-label-font-family: \"Source Sans Pro\";--cap-dynamic-filter-label-font-color: #5f6062;--cap-dynamic-filter-placeholder-font-weight: 600;--cap-dynamic-filter-placeholder-font-color: #5f6062;--cap-dynamic-filter-icon-opacity: 1;--cap-dynamic-filter-icon-color: var(--cap-primary-color)}body cpb-list-renderer-settings-sidebar .list-renderer-settings-sidebar{display:flex;flex-direction:column;height:100%}body cpb-list-renderer-settings-sidebar .list-renderer-settings-sidebar p-tabview.p-element{height:calc(100% - 60px);overflow:auto}body cpb-list-renderer-settings-sidebar .list-renderer-settings-sidebar p-tabview.p-element .p-tabview{flex:1}body cpb-list-renderer-settings-sidebar .list-renderer-settings-sidebar p-tabview.p-element .p-tabview a.p-tabview-nav-link{opacity:.6}body cpb-list-renderer-settings-sidebar .list-renderer-settings-sidebar p-tabview.p-element .p-tabview .p-highlight{background:#fff}body cpb-list-renderer-settings-sidebar .list-renderer-settings-sidebar p-tabview.p-element .p-tabview .p-highlight a{color:#4f5152;opacity:1}body cpb-list-renderer-settings-sidebar .list-renderer-settings-sidebar p-tabview.p-element .p-tabview .p-tabview-panels{padding:20px 0}body cpb-list-renderer-settings-sidebar .list-renderer-settings-sidebar p-tabview.p-element .p-tabview .p-tabview-panels .p-tabview-panel .placeholder-text{color:#5f6062;font-size:.9rem;display:block;margin-bottom:20px}body cpb-list-renderer-settings-sidebar .list-renderer-settings-sidebar .settings-list-items__item{background-color:#f9f9f9;font-size:1rem;font-weight:600;height:50px;border-radius:3px;padding:0 20px}body cpb-list-renderer-settings-sidebar .list-renderer-settings-sidebar .settings-list-items__item i{font-size:1rem;color:var(--cap-primary-color)}body cpb-list-renderer-settings-sidebar .list-renderer-settings-sidebar .settings-list-items__item i.fa-eye{color:#ddd}body cpb-list-renderer-settings-sidebar .list-renderer-settings-sidebar .settings-list-items__item .drag-handle,body cpb-list-renderer-settings-sidebar .list-renderer-settings-sidebar .settings-list-items__item .hide-handle{cursor:move;height:100%;width:40px;display:flex;justify-content:center;align-items:center;text-align:center}body cpb-list-renderer-settings-sidebar .list-renderer-settings-sidebar .settings-list-items__item .hide-handle{cursor:pointer}body cpb-list-renderer-settings-sidebar .list-renderer-settings-sidebar .sidebar-settings-buttons{background-color:#fff;border-top:1px solid #ddd;display:flex;justify-content:space-between;padding:20px 0}body .settings-list-items__item.cdk-drag-preview{z-index:9999!important;display:flex;padding:0 20px;font-size:1rem!important;font-weight:600;border-radius:3px;box-shadow:#0000003d 0 3px 8px;font-family:var(--primary-font)!important;background-color:#f9f9f9!important}body .settings-list-items__item.cdk-drag-preview i{font-size:1rem;color:var(--cap-primary-color)}body .settings-list-items__item.cdk-drag-preview .drag-handle,body .settings-list-items__item.cdk-drag-preview .hide-handle{cursor:move;height:100%;width:40px;display:flex;justify-content:center;align-items:center;text-align:center}body .settings-list-items__item.cdk-drag-preview .hide-handle{cursor:pointer}body .settings-list-items__item.cdk-drag-placeholder{z-index:9999!important;border:3px dashed #ddd}\n"],
        encapsulation: 2
      });
    }
  }
  return ListRendererSettingsSidebarComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TableActionToCtaButtonItemPipe = /*#__PURE__*/(() => {
  class TableActionToCtaButtonItemPipe {
    transform(tableActions) {
      return tableActions.map(tableAction => {
        return {
          label: tableAction.label,
          callback: () => tableAction.callback(null),
          icon: tableAction.icon
        };
      });
    }
    static {
      this.ɵfac = function TableActionToCtaButtonItemPipe_Factory(t) {
        return new (t || TableActionToCtaButtonItemPipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "tableActionToCtaButtonItem",
        type: TableActionToCtaButtonItemPipe,
        pure: true
      });
    }
  }
  return TableActionToCtaButtonItemPipe;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FilterByHiddenExpressionPipe = /*#__PURE__*/(() => {
  class FilterByHiddenExpressionPipe {
    transform(values, item) {
      return values.filter(value => {
        return !value.hiddenExpression || !value.hiddenExpression(item);
      });
    }
    static {
      this.ɵfac = function FilterByHiddenExpressionPipe_Factory(t) {
        return new (t || FilterByHiddenExpressionPipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "filterByHiddenExpression",
        type: FilterByHiddenExpressionPipe,
        pure: true
      });
    }
  }
  return FilterByHiddenExpressionPipe;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CapturumListRendererComponent = /*#__PURE__*/(() => {
  class CapturumListRendererComponent {
    constructor(listBuilderActionsService, listBuilderColumnsService, listBuilderFiltersService, listBuilderApiService, actionService, cdr, contextService, breakpointObserver, store, translateService, activatedRoute, tableRouteConfigService, localStorageService, infoTableConfigService, listRendererConfigService, listRendererService) {
      this.listBuilderActionsService = listBuilderActionsService;
      this.listBuilderColumnsService = listBuilderColumnsService;
      this.listBuilderFiltersService = listBuilderFiltersService;
      this.listBuilderApiService = listBuilderApiService;
      this.actionService = actionService;
      this.cdr = cdr;
      this.contextService = contextService;
      this.breakpointObserver = breakpointObserver;
      this.store = store;
      this.translateService = translateService;
      this.activatedRoute = activatedRoute;
      this.tableRouteConfigService = tableRouteConfigService;
      this.localStorageService = localStorageService;
      this.infoTableConfigService = infoTableConfigService;
      this.listRendererConfigService = listRendererConfigService;
      this.listRendererService = listRendererService;
      this.saveFiltersInUrl = false;
      this.scrollSelector = '.p-datatable-scrollable-body';
      this.noDataOnInitText = 'Start filtering to show results';
      this.listRendererDataChange = new EventEmitter();
      this.filterChange = new EventEmitter();
      this.data = [];
      this.apiOptions = {
        page: 1,
        perPage: 10
      };
      this.tableActions = [];
      this.topScroll = 0;
      this.paginationType = PaginationType.Paginated;
      this.PaginationType = PaginationType;
      this.headerType = HeaderType.Static;
      this.HeaderType = HeaderType;
      this.columns = [];
      this.loading = true;
      this.selectedRows = [];
      this.bulkActions = [];
      this.headerActions = [];
      this.scrollable = false;
      this.cardsView = true;
      this.infoTableTexts = {};
      this.verticalScroll = 0;
      this.scrollOffset = 80; // When user scroll down 80% of element height
      this.config = new BehaviorSubject(null);
      this.config$ = this.config.asObservable();
      this.destroy$ = new Subject();
      this.filtersReadySubject = new BehaviorSubject(false);
      this.listeningForScrollEvents = false;
      this.apiOptions$ = new BehaviorSubject(this.apiOptions);
      this.infoTableConfigService.getConfig().pipe(take$1(1)).subscribe(config => {
        this._defaultNoResultsText = config.defaultTexts.noResults;
      });
    }
    get key() {
      return this._key;
    }
    set key(value) {
      this._key = value;
      this.stateKey = `${this.storageKeyPrefix || ''}_state_${value}`;
      this.apiOptionsStateKey = `apiOptions-${value}`;
      this.tableSettingsStateKey = `tableSettings-${value}`;
    }
    get configuration() {
      return this._configuration;
    }
    get currentApiOptions() {
      return this.apiOptions$.getValue();
    }
    set configuration(value) {
      this._configuration = value;
      if (value) {
        this.config.next(value);
        this.prepareDependencies();
        this.setFiltersReady();
      }
    }
    ngAfterViewInit() {
      this.infoTable.templates.reset([...this.infoTable.templates, ...this.templates]);
      this.listenForRefreshEvents();
      this.buildFilters();
    }
    ngAfterContentInit() {
      this.bulkActionsTemplate = this.templates.find(template => template.getType() === 'bulkActions')?.template;
      this.tableActionsTemplate = this.templates.find(template => template.getType() === 'tableActions')?.template;
      this.footerTemplate = this.templates.find(template => template.getType() === 'footer')?.template;
    }
    ngOnChanges(changes) {
      if (!this.contextIsSet && this.key && !!this.context) {
        this.contextIsSet = true;
        this.contextService.setContext(this.contextKey || this.key, this.context);
        this.fetchListConfig();
      } else if (!this.contextIsSet && this.key) {
        this.fetchListConfig();
        this.contextIsSet = true;
      } else if (this.contextIsSet && changes.key) {
        this.fetchListConfig();
      }
      if (changes?.context?.currentValue) {
        this.contextService.setContext(this.contextKey || this.key, this.context);
      }
    }
    ngOnDestroy() {
      this.contextService.clearContextByKey(this.contextKey || this.key);
      this.destroy$.next(true);
      this.destroy$.complete();
    }
    ngDoCheck() {
      const filterHeight = 40;
      if (this.headerElement?.nativeElement) {
        this.tableStyleClass = `cpb-filter-height-${Math.ceil(this.headerElement.nativeElement.clientHeight / filterHeight)}`;
      }
    }
    buildFilters() {
      combineLatest([this.activatedRoute?.queryParams?.pipe(filter(Boolean), take$1(1)), this.config$.pipe(filter(Boolean), take$1(1))]).pipe(tap(([queryParams, {
        filters
      }]) => {
        if (queryParams) {
          this.routeFilters = this.retrieveStaticQueryParamFilters(queryParams);
        }
      }), map(([_, {
        filters,
        options
      }]) => ({
        filters,
        options
      })), takeUntil(this.destroy$)).subscribe(({
        filters,
        options
      }) => {
        this.setDynamicFilters(filters, options);
      });
    }
    setDynamicFilters(filters, options) {
      const tableFilterSettings = this.configureTableSettings ? this.localStorageService.getItem(this.tableSettingsStateKey)?.filters || [] : [];
      this.dynamicFilters = {
        filters: filters.fields.filter(filter => !this.configureTableSettings || !tableFilterSettings.find(setting => setting.field === filter.name)?.hidden).map(field => ({
          field: field.name,
          type: field.type === 'text' ? DynamicFilterType.input : field.type,
          icon: field.icon,
          label: field.label,
          default: field.default,
          placeholder: field.placeholder,
          showLabel: false,
          matchMode: field.operator,
          selectionLimit: field?.options?.selectionLimit,
          resetFilterOnHide: this.alwaysResetFilterOnHide || field?.options?.resetFilterOnHide,
          autofocusFilter: field?.options?.autofocusFilter,
          dependsOn: field.dependencies,
          preventDisableDependency: field.prevent_disable_dependency_field,
          options: field?.options?.action?.endpoint ? this.listBuilderApiService.data(field.options.action.endpoint, this.key).pipe(map(result => result.data.map(item => ({
            label: item.label,
            value: item.key
          })))) : field?.options?.items ? field.options.items.map(item => ({
            label: item.label,
            value: item.key
          })) : null,
          ...field.options,
          ...([DynamicFilterType.multiselect, DynamicFilterType.dropdown].includes(field.type) && field.dependencies ? {
            updateListOptions: listOptions => {
              return this.listBuilderApiService.data(field.options.action.endpoint, this.key, listOptions).pipe(map(result => result.data.map(item => ({
                label: item.label,
                value: item.key
              }))));
            }
          } : null)
        })),
        routeFilters: this.routeFilters,
        texts: {
          refresh: filters.refresh_button?.title || '',
          reset: filters.reset_button?.title || this.translateService.instant('reset.button'),
          apply: this.translateService.instant('button.submit'),
          cancel: this.translateService.instant('button.cancel')
        },
        icons: {
          reset: filters.reset_button?.icon || '',
          refresh: filters.refresh_button?.icon || ''
        }
      };
      if (filters.global_search?.enabled) {
        this.dynamicFilters.filters.unshift({
          field: SEARCH_BAR,
          label: this.translateService.instant('search.placeholder'),
          type: DynamicFilterType.input,
          matchMode: FilterMatchMode.LIKE,
          debounceTime: options?.searchDebounceTime,
          icon: 'fas fa-search',
          placeholder: this.translateService.instant('search.placeholder')
        });
      }
      this.cdr.detectChanges();
    }
    setColumnsByConfig(config) {
      let columns = config.columns.map(column => {
        if (this.columnActions.find(action => action.options.column_key === column.field)) {
          column.disableRowClick = true;
        }
        return column;
      });
      if (this.configureTableSettings) {
        const storageColumns = this.localStorageService.getItem(this.tableSettingsStateKey)?.columns || [];
        columns = columns.filter(column => !storageColumns.find(settingsColumn => settingsColumn.field === column.column)?.hidden);
      }
      this.columns = this.listBuilderColumnsService.prepareColumns(columns);
      this.cdr.detectChanges();
    }
    loadTableData(event) {
      this.config$.pipe(take$1(1)).subscribe(() => {
        if (event) {
          this.lazyLoadEvent = event;
          if (this.paginationType === PaginationType.VirtualScroll) {
            this.parameters = [{
              field: '_meta[offset]',
              value: event.first
            }];
            this.patchApiOptions({
              perPage: event.rows,
              parameters: this.parameters
            });
          }
          this.setSorting();
        }
      });
    }
    setTableData() {
      combineLatest([this.filtersReadySubject.pipe(filter(Boolean), take$1(1)), this.apiOptions$]).pipe(tap(() => this.loadingData = true), debounceTime(50), switchMap(([ready, apiOptions]) => this.config$.pipe(filter(Boolean), map(config => ({
        apiOptions,
        config
      })))), switchMap(({
        config,
        apiOptions
      }) => {
        const url = config.source.endpoint;
        const apiOptionsSort = apiOptions?.sort && apiOptions.sort.every(sort => {
          return !!sort.field;
        }) ? apiOptions?.sort : null;
        const sort = apiOptionsSort ?? config?.source?.options?.sort ?? [];
        return this.listBuilderApiService.data(url, this.contextKey || this.key, {
          ...apiOptions,
          filters: [...(apiOptions?.filters || []), ...(config.source?.options?.filters || [])],
          sort: sort && Array.isArray(sort) ? sort.filter(sortOption => sortOption.field) : []
        }).pipe(catchError(() => {
          return of({
            meta: {
              pagination: this.paginator
            },
            data: []
          });
        }));
      }), tap(result => {
        if (result?.meta) {
          this.paginator = {
            ...this.paginator,
            ...result.meta.pagination
          };
        }
      }), map(result => {
        const {
          filters,
          search,
          page
        } = this.apiOptions$.getValue();
        if (this.noDataOnInit && !filters?.length && !search) {
          this.infoTableTexts = {
            ...this.infoTableTexts,
            noResults: this.noDataOnInitText
          };
          this.paginator = {
            current_page: 1,
            per_page: this.paginator.per_page,
            total_pages: 0,
            total: 0,
            count: 0
          };
          return [];
        }
        this.infoTableTexts = {
          ...this.infoTableTexts,
          noResults: this._defaultNoResultsText
        };
        if (this.paginationType === PaginationType.InfiniteScroll) {
          // Ensure the previous table data is empty if current page is 1
          if (page === 1) {
            this.data = [];
          }
          return [...(this.data ?? []), ...result.data];
        }
        return result.data;
      }), tap(() => {
        this.loading = false;
      }), shareReplay(1), takeUntil(this.destroy$)).subscribe(result => {
        if (!this.listeningForScrollEvents && this.paginationType === PaginationType.InfiniteScroll) {
          this.listenForScrollEvents();
        }
        if (this.paginationType === PaginationType.VirtualScroll) {
          Array.prototype.splice.apply(this.data, [...[this.lazyLoadEvent.first, this.lazyLoadEvent.rows], ...result]);
          this.data = [...this.data];
        } else {
          this.data = result;
        }
        this.listRendererDataChange.emit(true);
        this.loadingData = false;
        this.cdr.detectChanges();
      });
    }
    fetchFilters(filtersValue) {
      this.config$.pipe(filter(Boolean), take$1(1)).subscribe(({
        filters
      }) => {
        this.parameters = null;
        this.loadingData = true;
        this.deleteSelectedRows();
        this.filtersWereUpdated(filtersValue, filters.fields);
        this.cdr.detectChanges();
      });
    }
    filtersWereUpdated(filters, filterConfigs) {
      const routeConfig = this.activatedRoute?.snapshot?.queryParams;
      const page = this.filtersReadySubject.getValue() ? 1 : this.apiOptions$.getValue().page;
      const apiOptions = ListRendererUtils.setApiOptions({
        ...this.apiOptions$.getValue(),
        page: this.saveFiltersInUrl && routeConfig?.page ? routeConfig?.page : page,
        perPage: this.saveFiltersInUrl && routeConfig?.perPage ? routeConfig?.perPage : this.apiOptions$.getValue()?.perPage,
        parameters: this.parameters
      }, filters, filterConfigs);
      this.resetInfiniteScrollDependencies();
      this.setApiOptions(apiOptions);
      this.setFiltersReady();
      this.setApiOptionsState();
      this.filterChange.emit(filters);
      this.cdr.detectChanges();
    }
    changePage(currentPage) {
      if (this.paginationType === PaginationType.Paginated) {
        this.loading = true;
      }
      this.patchApiOptions({
        page: currentPage + 1
      });
      if (this.paginationType === PaginationType.Paginated) {
        this.setApiOptionsState();
      }
    }
    changePerPage(perPage) {
      this.loading = true;
      this.patchApiOptions({
        perPage,
        page: 1
      });
      this.setApiOptionsState();
    }
    handleOnRowClick(item, ctrlKey) {
      if (this.clickAction) {
        this.clickAction = {
          ...this.clickAction,
          ctrlKey
        };
        this.actionService.executeAction(this.clickAction, item, this.contextKey || this.key);
      }
    }
    handleRowToggle(selectedRows) {
      this.selectedRows = selectedRows;
    }
    handleCancelSelection() {
      this.deleteSelectedRows();
    }
    deleteSelectedRows() {
      this.selectedRows = [];
      const localTableConfig = this.localStorageService.getItem(this.stateKey) || {};
      localTableConfig.selection = [];
      this.localStorageService.setItem(this.stateKey, localTableConfig);
    }
    handleDropEvent() {
      if (this.dragDropAction) {
        this.actionService.executeAction(this.dragDropAction, this.data, this.key, this.contextKey);
      }
    }
    handleColumnClick(event) {
      const action = this.columnActions.find(action => action.options.column_key === event.column);
      this.actionService.executeAction(action, event.row, this.key, this.contextKey);
    }
    updateTableData() {
      this.resetInfiniteScrollDependencies();
      this.refresh();
      this.cdr.detectChanges();
    }
    resetFilters() {
      this.filtersComponent?.dynamicFiltersRef?.resetFilters();
      this.infoTable.primeNGTable.reset();
    }
    handleResetFilter() {
      this.infoTable?.primeNGTable?.reset();
      this.infoTable?.primeNGTable?.saveState();
      this.setApiOptions({
        ...this.apiOptions$.getValue(),
        page: 1,
        search: null
      });
      this.filterChange.emit(null);
      this.deleteSelectedRows();
    }
    refresh() {
      this.filtersComponent?.refreshList();
    }
    // Static filters in queryParam should be in this order:
    // [staticFilters][order_id][in]: id-one, id-two
    // or when we need to specfy for which specific list renderer (last parameter is optional)
    // [staticFilters][order_id][in][list_key?]: id-one, id-two
    retrieveStaticQueryParamFilters(queryParams) {
      return DynamicFiltersUtils.retrieveQueryParamFilters(queryParams, true, this.key);
    }
    setSorting() {
      if (this.lazyLoadEvent?.sortField) {
        this.resetInfiniteScrollDependencies();
        const sortingApiOptions = {
          sort: [{
            field: this.lazyLoadEvent?.sortField,
            direction: this.lazyLoadEvent?.sortOrder === -1 ? 'desc' : 'asc'
          }]
        };
        if (this.paginationType === PaginationType.InfiniteScroll) {
          sortingApiOptions.page = 1;
          sortingApiOptions.perPage = this.currentApiOptions.perPage || 20;
        }
        this.patchApiOptions(sortingApiOptions);
      } else {
        this.patchApiOptions({
          sort: null
        });
      }
    }
    prepareDependencies() {
      this.config$.pipe(filter(Boolean)).subscribe(config => {
        const {
          fields,
          ...rest
        } = config.filters ?? {
          fields: [],
          global_search: null,
          reset_button: null,
          refresh_button: null
        };
        if (config.actions) {
          this.tableActions = this.listBuilderActionsService.prepareActions(config?.actions?.filter(action => action.type === ListRendererActionType.dotMenu) || [], this.key, this.contextKey);
          this.bulkActions = this.listBuilderActionsService.prepareActions(config?.actions?.filter(action => action.type === ListRendererActionType.bulkAction) || [], this.key, this.contextKey);
          this.columnActions = config?.actions?.filter(action => action.type === ListRendererActionType.onColumnClick).map(action => {
            return {
              key: action.key,
              options: action.action,
              type: action.action.type
            };
          });
          const dragDropAction = config?.actions?.find(action => action.type === ListRendererActionType.drop);
          if (dragDropAction) {
            this.dragDropAction = {
              key: dragDropAction.key,
              options: dragDropAction.action,
              type: dragDropAction.action.type
            };
          }
          this.headerActions = this.listBuilderActionsService.prepareActions(config?.actions?.filter(action => action.type === ListRendererActionType.headerButton) || [], this.key, this.contextKey);
          this.setColumnsByConfig(config);
          this.filters = this.listBuilderFiltersService.prepareFilters(fields || []);
          const clickAction = config?.actions?.find(action => action.type === ListRendererActionType.onRowClick);
          if (clickAction) {
            this.clickAction = {
              key: clickAction.key,
              options: clickAction.action,
              type: clickAction.action.type,
              ctrlKey: false
            };
          }
          this.filtersConfig = rest;
          if (config?.pagination) {
            this.paginationType = config.pagination;
          }
          if (this.paginationType === PaginationType.VirtualScroll) {
            this.rows = 20;
            this.scrollHeight = '800px';
            this.scrollable = true;
          }
          if (this.paginationType === PaginationType.InfiniteScroll) {
            this.apiOptions = {
              perPage: config?.options?.perPage || 20,
              page: 1
            };
            this.patchApiOptions({
              perPage: config?.options?.perPage || 20
            });
            if (config?.options?.scrollable) {
              this.scrollable = config.options.scrollable;
            }
          }
          if (config?.noDataOnInit) {
            this.noDataOnInit = config?.noDataOnInit;
          }
          if (config?.headerPosition) {
            this.headerType = config.headerPosition;
          }
          if (typeof config?.options?.cards_view !== 'undefined') {
            this.cardsView = config.options?.cards_view;
          }
          if (this.tableActions?.length) {
            this.columns.push(this.listBuilderColumnsService.actionColumn);
          }
          if (this.paginationType === PaginationType.Paginated) {
            if (this.perPageOptions?.length) {
              const routeConfigPerPage = this.activatedRoute?.snapshot?.queryParams?.perPage;
              this.apiOptions = {
                ...this.apiOptions$.value,
                perPage: this.saveFiltersInUrl ? routeConfigPerPage : this.perPageOptions[0].value,
                page: 1
              };
              this.apiOptions$.next(this.apiOptions);
            }
            this.patchApiOptions(this.getApiOptionsState());
          }
          this.setTableData();
          if (!this.filters.length && !config.filters?.global_search?.enabled) {
            this.setFiltersReady();
          }
          if (this.listRendererConfigService.config && this.listRendererConfigService.config[this.key]) {
            this.rowStyleClassExpression = this.listRendererConfigService.config[this.key].styleClassExpression;
          }
          this.cdr.detectChanges();
          this.setColumns(config);
        }
      });
    }
    openTableSettingsSidebar() {
      this.showSettingsSidebar = true;
    }
    onSettingsChange(settings) {
      this.showSettingsSidebar = false;
      this.localStorageService.setItem(this.tableSettingsStateKey, settings);
      if (settings.filters) {
        this.resetFilters();
        this.setDynamicFilters(this.config.getValue().filters, this.config.getValue().columns);
      }
      if (settings.columns) {
        this.setColumnsByConfig(this.config.getValue());
      }
    }
    setApiOptionsState() {
      const {
        sort,
        ...apiOptions
      } = this.apiOptions$.value;
      if (this.saveFiltersInUrl) {
        this.tableRouteConfigService.saveConfigInParams({
          page: apiOptions.page,
          perPage: apiOptions.perPage
        });
      }
      localStorage.setItem(this.apiOptionsStateKey, JSON.stringify(apiOptions));
    }
    getApiOptionsState() {
      return JSON.parse(localStorage.getItem(this.apiOptionsStateKey));
    }
    fetchListConfig() {
      this.listBuilderApiService.getConfig(this.contextKey || this.key, this.key).subscribe(config => {
        this.config.next(config);
        this.listenForScreenResize(config);
        this.store.dispatch(new SetListConfiguration(this.key, config));
      });
      this.prepareDependencies();
    }
    setApiOptions(apiOptions) {
      this.apiOptions$.next(apiOptions);
    }
    patchApiOptions(apiOptions) {
      this.apiOptions$.next({
        ...this.apiOptions$.value,
        ...apiOptions
      });
    }
    resetInfiniteScrollDependencies() {
      this.verticalScroll = 0;
      this.data = [];
      this.loading = true;
    }
    listenForRefreshEvents() {
      merge(this.listRendererService.getRefreshTable(), this.actionService.getActionExecutions().pipe(filter(message => !!message?.action?.options?.refresh))).pipe(takeUntil(this.destroy$)).subscribe(() => this.updateTableData());
    }
    setFiltersReady() {
      if (!this.filtersReadySubject.value) {
        this.filtersReadySubject.next(true);
      }
    }
    listenForScrollEvents() {
      const target = this.scrollable ? document.querySelector(this.scrollSelector) : window;
      if (target) {
        fromEvent(target, 'scroll').pipe(filter(() => !this.loadingData),
        // do not listen to scroll since we already have request in progress for getting data
        takeUntil(this.destroy$)).subscribe(event => {
          const eventTarget = this.scrollable ? event.target : event.target['scrollingElement'];
          this.topScroll = eventTarget.scrollTop;
          const height = eventTarget.scrollHeight;
          if (this.topScroll > this.verticalScroll && this.apiOptions$?.value?.page < this.paginator?.total_pages) {
            this.verticalScroll = height * this.scrollOffset / 100;
            this.changePage(this.apiOptions$?.value?.page || 1);
            this.cdr.detectChanges();
          }
        });
      }
      this.listeningForScrollEvents = true;
    }
    listenForScreenResize(config) {
      this.breakpointObserver.observe([Breakpoints.XSmall, Breakpoints.Small, Breakpoints.Tablet, Breakpoints.Web]).pipe(takeUntil(this.destroy$)).subscribe(() => {
        this.setColumns(config);
      });
    }
    setColumns(config) {
      if (this.breakpointObserver.isMatched([Breakpoints.XSmall])) {
        this.columns = this.mapColumnsByBreakpoint(this.columns, ListRendererBreakpoints.mobile, config);
      } else if (this.breakpointObserver.isMatched([Breakpoints.Web])) {
        this.columns = this.mapColumnsByBreakpoint(this.columns, ListRendererBreakpoints.desktop, config);
      } else if (this.breakpointObserver.isMatched(Breakpoints.Small)) {
        this.columns = this.mapColumnsByBreakpoint(this.columns, ListRendererBreakpoints.tablet, config);
      }
    }
    mapColumnsByBreakpoint(columns, breakpoint, listRendererConfig) {
      return columns.map(column => {
        const columnConfig = listRendererConfig.columns.find(config => config.column === column.field);
        if (columnConfig) {
          column.hidden = columnConfig.breakpoints && columnConfig.breakpoints[breakpoint] === false;
        }
        return column;
      });
    }
    static {
      this.ɵfac = function CapturumListRendererComponent_Factory(t) {
        return new (t || CapturumListRendererComponent)(i0.ɵɵdirectiveInject(ListRendererActionsService), i0.ɵɵdirectiveInject(ListRendererColumnsService), i0.ɵɵdirectiveInject(ListRendererFiltersService), i0.ɵɵdirectiveInject(ListRendererApiService), i0.ɵɵdirectiveInject(i1.CapturumBuilderActionService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.CapturumBuildersContextService), i0.ɵɵdirectiveInject(i1$2.BreakpointObserver), i0.ɵɵdirectiveInject(i1$5.Store), i0.ɵɵdirectiveInject(i2.TranslateService), i0.ɵɵdirectiveInject(i9.ActivatedRoute), i0.ɵɵdirectiveInject(i10.TableRouteConfigService), i0.ɵɵdirectiveInject(i10.LocalStorageService), i0.ɵɵdirectiveInject(i11.InfoTableConfigService), i0.ɵɵdirectiveInject(ListRendererConfigService), i0.ɵɵdirectiveInject(ListRendererService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CapturumListRendererComponent,
        selectors: [["cpb-list-renderer"]],
        contentQueries: function CapturumListRendererComponent_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, CapturumTemplateDirective, 4);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.templates = _t);
          }
        },
        viewQuery: function CapturumListRendererComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(CapturumInfoTableComponent, 5);
            i0.ɵɵviewQuery(_c6, 5);
            i0.ɵɵviewQuery(ListRendererFiltersComponent, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.infoTable = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.headerElement = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.filtersComponent = _t.first);
          }
        },
        inputs: {
          context: "context",
          contextKey: "contextKey",
          noDataOnInit: "noDataOnInit",
          saveFiltersInUrl: "saveFiltersInUrl",
          alwaysResetFilterOnHide: "alwaysResetFilterOnHide",
          dataKey: "dataKey",
          scrollSelector: "scrollSelector",
          noDataOnInitText: "noDataOnInitText",
          perPageOptions: "perPageOptions",
          storageKeyPrefix: "storageKeyPrefix",
          sidebarFiltering: "sidebarFiltering",
          configureTableSettings: "configureTableSettings",
          key: "key",
          configuration: "configuration"
        },
        outputs: {
          listRendererDataChange: "listRendererDataChange",
          filterChange: "filterChange"
        },
        features: [i0.ɵɵNgOnChangesFeature],
        decls: 17,
        vars: 45,
        consts: [[1, "cpb-list-renderer"], ["class", "cpb-header-actions", 4, "ngIf"], [1, "header", 3, "ngClass"], ["header", ""], [3, "sidebarFiltering", "config", "routeFilters", "filters", "key", "filterReset", "filtersChanges", 4, "ngIf"], ["styleClass", "primary", "class", "table-settings-button ms-2", "icon", "fas fa-cog", 3, "onClick", 4, "ngIf"], [1, "content", 3, "ngClass"], ["content", ""], [3, "stateKey", "routeFilters", "columns", "dataKey", "scrollable", "data", "lazyLoading", "cardsView", "loading", "pagination", "virtualScroll", "virtualScrollItemSize", "rows", "texts", "scrollHeight", "selectable", "selectedRows", "reorderableRows", "styleClass", "styleClassExpression", "onLazyLoad", "onRowClick", "onRowCtrlClick", "selectedRowsChange", "onRowReorder", "onColumnClick"], ["capTemplate", "actions"], [4, "ngFor", "ngForOf"], ["capTemplate", "infoTableFooter"], [3, "loading", "paginator", "perPageOptions", "changePage", "changePerPage", 4, "ngIf"], [3, "actions", "contentTemplate", "selectedItems", "cancelSelection", "actionExecuted", 4, "ngIf"], [3, "menuItems"], ["styleClass", "cap-dynamic-filters-sidebar", 3, "visible", "title", "visibleChange", 4, "ngIf"], [1, "cpb-header-actions"], [3, "actions"], [3, "sidebarFiltering", "config", "routeFilters", "filters", "key", "filterReset", "filtersChanges"], ["styleClass", "primary", "icon", "fas fa-cog", 1, "table-settings-button", "ms-2", 3, "onClick"], [4, "ngIf", "ngIfElse"], ["defaultTableActions", ""], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], [3, "actions", "item"], [3, "capTemplate"], [3, "column", "index", "widget", "context", "widgetOptions", "item"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], [3, "loading", "paginator", "perPageOptions", "changePage", "changePerPage"], [3, "actions", "contentTemplate", "selectedItems", "cancelSelection", "actionExecuted"], ["styleClass", "cap-dynamic-filters-sidebar", 3, "visible", "title", "visibleChange"], [3, "stateKey", "config", "onSettingsChange", "onSidebarClose"]],
        template: function CapturumListRendererComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵtemplate(1, CapturumListRendererComponent_div_1_Template, 2, 1, "div", 1);
            i0.ɵɵelementStart(2, "div", 2, 3);
            i0.ɵɵtemplate(4, CapturumListRendererComponent_cpb_list_renderer_filters_4_Template, 1, 5, "cpb-list-renderer-filters", 4);
            i0.ɵɵtemplate(5, CapturumListRendererComponent_cap_button_5_Template, 1, 0, "cap-button", 5);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(6, "div", 6, 7)(8, "cap-info-table", 8);
            i0.ɵɵlistener("onLazyLoad", function CapturumListRendererComponent_Template_cap_info_table_onLazyLoad_8_listener($event) {
              return ctx.loadTableData($event);
            })("onRowClick", function CapturumListRendererComponent_Template_cap_info_table_onRowClick_8_listener($event) {
              return ctx.handleOnRowClick($event, false);
            })("onRowCtrlClick", function CapturumListRendererComponent_Template_cap_info_table_onRowCtrlClick_8_listener($event) {
              return ctx.handleOnRowClick($event, true);
            })("selectedRowsChange", function CapturumListRendererComponent_Template_cap_info_table_selectedRowsChange_8_listener($event) {
              return ctx.handleRowToggle($event);
            })("onRowReorder", function CapturumListRendererComponent_Template_cap_info_table_onRowReorder_8_listener() {
              return ctx.handleDropEvent();
            })("onColumnClick", function CapturumListRendererComponent_Template_cap_info_table_onColumnClick_8_listener($event) {
              return ctx.handleColumnClick($event);
            });
            i0.ɵɵtemplate(9, CapturumListRendererComponent_ng_template_9_Template, 3, 2, "ng-template", 9);
            i0.ɵɵtemplate(10, CapturumListRendererComponent_ng_container_10_Template, 2, 1, "ng-container", 10);
            i0.ɵɵtemplate(11, CapturumListRendererComponent_ng_template_11_Template, 1, 4, "ng-template", 11);
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(12, CapturumListRendererComponent_cpb_list_renderer_paginator_12_Template, 1, 3, "cpb-list-renderer-paginator", 12);
            i0.ɵɵtemplate(13, CapturumListRendererComponent_cpb_list_renderer_bulk_actions_13_Template, 1, 3, "cpb-list-renderer-bulk-actions", 13);
            i0.ɵɵelement(14, "cap-cta-button", 14);
            i0.ɵɵpipe(15, "tableActionToCtaButtonItem");
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(16, CapturumListRendererComponent_cap_sidebar_16_Template, 4, 8, "cap-sidebar", 15);
          }
          if (rf & 2) {
            i0.ɵɵclassProp("bulk-actions-opened", ctx.selectedRows.length > 0);
            i0.ɵɵattribute("data-test", "builder-" + ctx.key);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.headerActions.length);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(37, _c9, ctx.headerType === ctx.HeaderType.Sticky, ctx.configureTableSettings));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.dynamicFilters);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.configureTableSettings && ctx.dynamicFilters);
            i0.ɵɵadvance(1);
            i0.ɵɵclassProp("table-columns-view", !ctx.cardsView);
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction4(40, _c10, ctx.paginationType === ctx.PaginationType.InfiniteScroll && ctx.topScroll > 50, ctx.paginationType === ctx.PaginationType.InfiniteScroll && ctx.topScroll <= 50, ctx.paginationType === ctx.PaginationType.VirtualScroll, ctx.headerType === ctx.HeaderType.Sticky));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("stateKey", ctx.stateKey)("routeFilters", ctx.saveFiltersInUrl)("columns", ctx.columns)("dataKey", ctx.dataKey)("scrollable", ctx.scrollable)("data", ctx.data)("lazyLoading", true)("cardsView", ctx.cardsView)("loading", ctx.loading)("pagination", false)("virtualScroll", ctx.paginationType === ctx.PaginationType.VirtualScroll)("virtualScrollItemSize", 50)("rows", ctx.rows)("texts", ctx.infoTableTexts)("scrollHeight", ctx.scrollHeight)("selectable", ctx.bulkActions.length > 0)("selectedRows", ctx.selectedRows)("reorderableRows", !!ctx.dragDropAction)("styleClass", ctx.tableStyleClass)("styleClassExpression", ctx.rowStyleClassExpression);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngForOf", ctx.columns);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.paginationType === ctx.PaginationType.Paginated);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.selectedRows.length > 0 && ctx.bulkActions.length > 0);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("menuItems", i0.ɵɵpipeBind1(15, 35, ctx.headerActions));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.showSettingsSidebar);
          }
        },
        dependencies: [i1$1.NgClass, i1$1.NgForOf, i1$1.NgIf, i1$1.NgTemplateOutlet, i11.CapturumInfoTableComponent, i10.CapturumRowActionComponent, i10.CapturumTemplateDirective, i3.CapturumButtonComponent, i16.CtaButtonComponent, i17.CapturumSidebarComponent, ListRendererFiltersComponent, ListRendererPaginatorComponent, ListRendererDynamicWidgetComponent, ListRendererBulkActionsComponent, ListRendererHeaderActionsComponent, ListRendererSettingsSidebarComponent, i1$1.AsyncPipe, i2.TranslatePipe, TableActionToCtaButtonItemPipe, FilterByHiddenExpressionPipe],
        styles: ["[_ngcontent-%COMP%]:root{--cap-input-height: 30px;--cap-dynamic-filter-input-height: 30px;--cap-dynamic-filter-border-radius: 5px;--cap-dynamic-filter-border-width: 1px;--cap-dynamic-filters-hide-filters-on-mobile: false;--cap-dynamic-filters-filter-flex: 1;--cap-dynamic-filters-flex-wrap: wrap;--cap-dynamic-filter-width: 200px;--cap-dynamic-filter-label-font-size: 14px;--cap-dynamic-filter-label-font-weight: 600;--cap-dynamic-filter-label-font-family: \"Source Sans Pro\";--cap-dynamic-filter-label-font-color: #5f6062;--cap-dynamic-filter-placeholder-font-weight: 600;--cap-dynamic-filter-placeholder-font-color: #5f6062;--cap-dynamic-filter-icon-opacity: 1;--cap-dynamic-filter-icon-color: var(--cap-primary-color)}[_nghost-%COMP%]     cap-cta-button{position:fixed;bottom:30px;right:30px;display:none}@media (max-width: 599.98px) and (orientation: portrait),(max-width: 959.98px) and (orientation: landscape){[_nghost-%COMP%]     cap-cta-button{display:block}}[_nghost-%COMP%]     .sticky-headings .p-datatable-tbody, [_nghost-%COMP%]     .sticky-headings .p-datatable-thead{display:none}[_nghost-%COMP%]     .header--sticky{background-color:#eff1f5;position:sticky}[_nghost-%COMP%]     .header--sticky .table-filters{padding:10px 0}[_nghost-%COMP%]     .header--sticky .sticky-headings table{border-spacing:0}[_nghost-%COMP%]     .header--sticky .sticky-headings .p-datatable-thead{display:contents}  .table-header--sticky cap-info-table p-table .p-component .p-datatable-wrapper table .p-datatable-thead cap-info-table-header>tr>th{position:sticky;background-color:#eff1f5}.content[_ngcontent-%COMP%]{transition:.5s all}.header[_ngcontent-%COMP%]{top:0;z-index:99}.header[_ngcontent-%COMP%]   cpb-list-renderer-filters[_ngcontent-%COMP%]{flex:1}[_nghost-%COMP%]     .cpb-filter-height-1 .p-datatable-thead cap-info-table-header>tr>th{top:0}[_nghost-%COMP%]     .cpb-filter-height-2 .p-datatable-thead cap-info-table-header>tr>th{top:50px}[_nghost-%COMP%]     .cpb-filter-height-3 .p-datatable-thead cap-info-table-header>tr>th{top:100px}[_nghost-%COMP%]     .cpb-filter-height-4 .p-datatable-thead cap-info-table-header>tr>th{top:140px}@media screen and (max-width: 64em){[_nghost-%COMP%]     .p-datatable .p-datatable-thead cap-info-table-header>tr>th{top:0}}.bulk-actions-opened[_ngcontent-%COMP%]{margin-bottom:75px}  .cpb-list-renderer{position:relative}  .cpb-list-renderer .row-action__items li .row-action__icon{flex:0 0 22px;max-width:22px}@media (max-width: 599.98px) and (orientation: portrait),(max-width: 959.98px) and (orientation: landscape){[_nghost-%COMP%]     .table-columns-view .cap-info-table.p-datatable .p-datatable-thead{display:table-header-group}[_nghost-%COMP%]     .table-columns-view .cap-info-table.p-datatable .p-datatable-tbody tr{display:table-row;box-shadow:none;border-radius:5px;margin-bottom:.3rem}[_nghost-%COMP%]     .table-columns-view .cap-info-table.p-datatable .p-datatable-tbody tr td.cap-info-table__column-actions{display:table-cell}[_nghost-%COMP%]     .table-columns-view .cap-info-table.p-datatable .p-datatable-tbody tr td .cap-info-table__mobile-column{display:block;height:-moz-fit-content;height:fit-content}[_nghost-%COMP%]     .table-columns-view .cap-info-table.p-datatable .p-datatable-tbody tr td .cap-info-table__mobile-column .cap-info-table__mobile-header{display:none}[_nghost-%COMP%]     .table-columns-view .cap-info-table.p-datatable .p-datatable-tbody tr td .cap-info-table__mobile-column .cap-cell-tooltip-container span{white-space:normal}}[_nghost-%COMP%]     .cpb-list-renderer .cap-info-table .p-datatable-virtual-scrollable-body .p-datatable-thead, [_nghost-%COMP%]     .cpb-list-renderer .cap-info-table .p-datatable-virtual-scrollable-body .p-datatable-tbody, [_nghost-%COMP%]     .cpb-list-renderer .cap-info-table .p-datatable-virtual-scrollable-body .p-datatable-tfoot{display:table-row-group}[_nghost-%COMP%]     .cpb-list-renderer .cap-info-table.p-datatable-scrollable .p-datatable-wrapper .p-datatable-table>.p-datatable-thead, [_nghost-%COMP%]     .cpb-list-renderer .cap-info-table.p-datatable-scrollable .p-datatable-wrapper .p-datatable-virtual-scrollable-body>.cdk-virtual-scroll-content-wrapper>.p-datatable-table>.p-datatable-thead{position:static}@media (max-width: 599.98px) and (orientation: portrait),(max-width: 959.98px) and (orientation: landscape){.cpb-header-actions[_ngcontent-%COMP%]{display:none}}"],
        changeDetection: 0
      });
    }
  }
  return CapturumListRendererComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ExtractOptionsPipe = /*#__PURE__*/(() => {
  class ExtractOptionsPipe {
    constructor(listBuilderApiService) {
      this.listBuilderApiService = listBuilderApiService;
    }
    transform(options, key) {
      if (options?.action?.endpoint) {
        return this.listBuilderApiService.data(options.action.endpoint, key).pipe(map(result => result.data.map(item => ({
          label: item.label,
          value: item.key
        }))));
      } else if (options?.items) {
        return of(options?.items.map(item => ({
          label: item.label,
          value: item.key
        })));
      }
      return of(options?.action.options ?? []);
    }
    static {
      this.ɵfac = function ExtractOptionsPipe_Factory(t) {
        return new (t || ExtractOptionsPipe)(i0.ɵɵdirectiveInject(ListRendererApiService, 16));
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "extractOptions",
        type: ExtractOptionsPipe,
        pure: true
      });
    }
  }
  return ExtractOptionsPipe;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DateFilterSelectionModePipe = /*#__PURE__*/(() => {
  class DateFilterSelectionModePipe {
    transform(matchMode) {
      if (matchMode === FilterMatchMode.BETWEEN || matchMode === FilterMatchMode.DATEBETWEEN) {
        return 'range';
      }
      return 'single';
    }
    static {
      this.ɵfac = function DateFilterSelectionModePipe_Factory(t) {
        return new (t || DateFilterSelectionModePipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "dateFilterSelectionModePipe",
        type: DateFilterSelectionModePipe,
        pure: true
      });
    }
  }
  return DateFilterSelectionModePipe;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const LIST_RENDERER_MODULE_CONFIG = new InjectionToken('List renderer module config');
const translateModule = TranslateModule;
// @dynamic
let CapturumListRendererModule = /*#__PURE__*/(() => {
  class CapturumListRendererModule {
    constructor(listRendererConfigService, listRendererModuleConfig = []) {
      this.listRendererConfigService = listRendererConfigService;
      this.listRendererModuleConfig = listRendererModuleConfig;
      if (!listRendererModuleConfig) {
        return;
      }
      listRendererModuleConfig.forEach(config => {
        this.listRendererConfigService.addConfig(config);
      });
    }
    static forRoot(config) {
      return {
        ngModule: CapturumListRendererModule,
        providers: [{
          provide: LIST_RENDERER_MODULE_CONFIG,
          useValue: config,
          multi: true
        }, {
          provide: DYNAMIC_FILTER_COMPONENTS,
          useValue: [...(config?.filters || []), ...dynamicFilterComponents]
        }]
      };
    }
    static forChild(config) {
      return {
        ngModule: CapturumListRendererModule,
        providers: [{
          provide: LIST_RENDERER_MODULE_CONFIG,
          useValue: config,
          multi: true
        }]
      };
    }
    static {
      this.ɵfac = function CapturumListRendererModule_Factory(t) {
        return new (t || CapturumListRendererModule)(i0.ɵɵinject(ListRendererConfigService), i0.ɵɵinject(LIST_RENDERER_MODULE_CONFIG, 8));
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: CapturumListRendererModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: [ListRendererActionsService, ListRendererColumnsService, ListRendererFiltersService, ListRendererWidgetsService, InterpolationPipe, ConcatenatePipe, CapturumDialogService],
        imports: [CommonModule, CapturumInfoTableModule, NgxsModule.forFeature([ListRendererState]), CapturumDynamicFiltersModule, CapturumSharedModule, CapturumSkeletonModule, CapturumDropdownModule, ReactiveFormsModule, PaginatorModule, CapturumButtonModule, CapturumCheckboxModule, CapturumCalendarModule, CapturumMultiSelectModule, HttpClientModule, CapturumPaginatorModule, translateModule, CapturumBuilderCoreModule, CapturumAutocompleteModule, OverlayPanelModule, CapturumCtaButtonModule, ChipsModule, CapturumSharedModule, CapturumSidebarModule, TabViewModule, DragDropModule]
      });
    }
  }
  return CapturumListRendererModule;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// tslint:disable-next-line:directive-class-suffix
let ListRendererConfigBase = /*#__PURE__*/(() => {
  class ListRendererConfigBase {
    static {
      this.ɵfac = function ListRendererConfigBase_Factory(t) {
        return new (t || ListRendererConfigBase)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: ListRendererConfigBase
      });
    }
  }
  return ListRendererConfigBase;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * Public API Surface of builders/list-renderer
 */

/**
 * Generated bundle index. Do not edit.
 */

export { CapturumListRendererComponent, CapturumListRendererModule, ComponentHostDirective, LinkHrefType, ListRendererActionsService, ListRendererApiService, ListRendererColumnsService, ListRendererConfigBase, ListRendererConfigService, ListRendererDynamicWidgetComponent, ListRendererFiltersComponent, ListRendererFiltersService, ListRendererHeaderActionsComponent, ListRendererPaginatorComponent, ListRendererService, ListRendererUtils, ListRendererWidgetBase, ListRendererWidgetImageComponent, ListRendererWidgetLinkComponent, ListRendererWidgetsService, PaginationType, translateModule };
